import enLocale from 'element-ui/lib/locale/lang/en';

// 退款弹窗
import networkApplicationEn from '@/language/networkApplication/en.js';
import chargebackAlertEn from '@/views/transaction/chargeback-alert/locale/en.js';
import transactionRefundDialogEn from '@/views/transaction/transaction-details/components/refundDialog/locale/en.js';
export default {
  message: {
    lang: {
      'zh-cn': '中文',
      en: 'English',
    },
    ...transactionRefundDialogEn,
    ...chargebackAlertEn,
    ...networkApplicationEn,
    index: {
      index: 'Home',
      welcome: 'Hello, {user}',
      pending: 'Pending',
      untreatedRefuseTransaction: 'Unhandled chargebacks',
      untreatedAdjustmentTransaction: 'Unprocessed transactions',
      overview: ' Overview',
      transactionSuccessRate: 'Transaction success rate',
      transactionSuccessToday: 'Today\'s successful transactions',
      transactionRefuseToday: 'Today\'s chargebacks',
      transactionCount: '{count} Pen',
      transactionAmount7Day: 'Seven-day transactions amount',
      transactionCount7Day: 'Seven-day transactions number',
      transactionSummary: 'Transaction summary',
      refuseAmount7Day: 'Seven-day chargeback amount',
      refuseCount7Day: 'Seven-day chargeback number',
      amount: 'Amount',
      count: 'Number',
      welcomeTo: 'Welcome use payment system',
      businessGoals: 'Multiple payment schemes enable you to achieve business goals.',
      provides: 'PacyPay provides you with one-stop payment mode to enable you to easily receive online orders from all over the world. ' +
        'To help you expand your business in the world and open up new markets.',
      attentionTip: 'To avoid your loss, please check the order in time',
      newRefuseTxn: 'New chargeback transactions',
      refuseTxnTitle: 'Chargeback transactions',
      new: 'New',
      appealFailed: 'First rebuttal failed',
      countUnit: '',
      refuseTxn: 'Chargeback transactions(First rebuttal failed)',
      transaction: 'Transaction summary',
      doMore: 'Do more with Onerway',
      addTeamOperator: 'Add a team <br/>operator',
      websiteManagement: 'Website <br/>management',
      sendMoney: 'Send money',
      successTxnAmount: 'Amount of successful transactions',
      successTxnAmountTip: 'Amount of current currency successful transactions',
      successTxnCount: 'Number of successful transactions',
      successTxnCountTip: 'Number of current currency successful transactions',
      chargebackAmount: 'Amount of chargebacks',
      chargebackAmountTip: 'Amount of current currency chargebacks',
      refuseCount: 'Number of chargebacks',
      refuseCountTip: 'Number of current currency chargebacks',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
      noPermission: 'The current account does not have permission to view',
      successTxn: 'Successful transactions',
      refuseTxt: 'Chargeback transactions',
      successRate: 'Success rate',
      amountStatistics: 'Amount statistics',
      paidAmount: 'Payment amount',
      paidAmountTip: 'Payment amount = Deduction amount + Frozen amount',
      totalTxnAmount: 'Amount',
      totalTxnAmountTip: 'Transaction amount = sale (success) + capture (success) + refund (success) + chargeback (Add) + chargeback (Rebuttal succeeded) transaction amount summary',
      Upgrading: 'Function upgrade in progress',
      today: 'Today',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      yesterdayTotalAmount: 'Amount',
      yesterdayTotalAmountTip: 'The total successful amount of yesterday\'s sale and capture transactions;',
      yesterdayTotalCount: 'Number',
      yesterdayTotalCountTip: 'The total number of successful sales and capture transactions yesterday;',
      totalTxn: 'Total transaction',
      yesterdayTxn: 'Yesterday\'s transaction',
      refuseRate: 'Chargeback rate',
      refundRate: 'Refund rate',
      refuseNumber: 'Number of chargebacks',
      refundRateTip: '',
      refuseRateTip: '',
      addOtherCurrency: 'Open an account in another currency',
      accountTotalAmount: 'Total Balance',
      totalAmountTips: 'Valuing account totals in {currency} (Updated on {time})',
      laterAgain: 'Please try again later',
      open: 'Open',
      noTransferTips: 'No transaction yet! Hurry up and complete your first transaction',
      // TODO
      currencySettings: '币种管理',
      selectCurrencySettings: '请选择需要展示在首页的币种',
      // 币种余额不为0，不允许隐藏
      currencyNotHidingTips: 'Currency balance is not 0, hiding is not allowed',
    },
    user: {
      forgetPassword: 'Forgot your password?',
      confirmTip: 'Fill in the following information to confirm your identity.',
      email: 'Email',
      loginEmail: 'Email',
      contactEmail: 'Contact email',
      captcha: 'Verification code',
      sendCaptcha: 'Get verification code',
      restTime: 'Remaining ({time}S)',
      backToLogin: 'Back',
      loginPassword: 'Password',
      newPasswordSettingTip: 'New password setting',
      newPasword: 'New password',
      confirmPasword: 'Repeat new password',
      login: 'Log in',
      captchRefresh: 'Click the picture to refresh',
      registerNow: 'Register now',
      noaccount: 'No account yet',
      logout: 'Log out',
      updatePassword: 'Reset password',
      oldPassword: 'Original password',
      forgetPwd: 'Forgot password',
      forgetPwdTip: 'Fill in the following information to confirm your identity',
      resetPwdTip: 'Your login mailbox：{email}',
      register: 'Register',
      registerTitle: 'Apply for your ONERWAY account',
      registerDesc: 'A worldwide payment network that provides fast, low-cost and secure international payments.',
      phone: 'Mobile phone number',
      dynamicCode: 'Dynamic verification code',
      supplement: 'Complete information',
      // eslint-disable-next-line max-len
      supplementTips: 'To access all features, please complete the identity verification process.',
      supplementMerchantName: 'The current certified enterprise is',
      accountAddress: 'Account address',
      realname: 'Real name',
      idCard: 'ID card number',
      idCardExpire: 'ID card validity period',
      longEffective: 'Long-term',
      realnameInfo: 'Real-name information',
      contactAddress: 'Contact address',
      detailAddress: 'Detailed address',
      businessRegistration: 'Registered country/region',
      merchantName: 'Company name',
      detailAddressEn: 'Full Address - English only',
      merchantNameEn: 'Business Name - English only',
      merchantRegisterDate: 'Date of Enterprise Registration',
      merchantNameEnTips: 'Please fill in the complete English name of the enterprise. Chinese characters are not allowed.',
      legalPersonName: 'Legal representative name',
      legalPersonNumber: 'Legal ID number (or identity ID)',
      businessLicense: 'Business license number',
      businessLicenseDate: 'Business license validity period',
      uploadInfo: 'Upload required information',
      shareholderInfo: 'Shareholder information',
      shareholderRequire: '*Shareholders with shares exceeding 10% need to provide relevant shareholder information',
      shareholderRatioInputTips: 'Shareholding ratio',
      shareholderName: 'Shareholder name',
      shareholderNameInputTips: 'Name and proportion of shareholders with equity greater than 10%',
      shareholderNumber: 'Shareholder ID card',
      shareholderNumberDate: 'Validity period of shareholder ID card',
      shareholderMaterial: 'Shareholder information',
      deleteShareholder: 'Delete',
      addShareholder: 'Add',
      companyInformation: 'Company information',
      legalInformation: 'Legal representative information',
      pleaseCompleteLegalInformation: 'Please complete the legal representative information',
      pleaseUploadMaterial: 'Please upload the necessary material information',
      failedToObtainTheMaterial: 'Failed to obtain the material item, please try again later',
      pleaseContinue: 'Please continue to complete the information for registration completion',
      pleaseSelectBusinessType: 'Please select the type of business registration',
      acquiring: 'Acquiring',
      payout: 'Payout',
      collection: 'Collection',
      functionDevelopment: 'Function is under development, please try again later',
      personalAccount: 'Personal account',
      corporateAccount: 'Corporate account',
      authentication: 'Your real-name authentication submission is successful, we will review for you!',
      passwordStrength: 'Password strength',
      agreement: '"OnerWay Service Agreement"',
      agreement1: 'OnerWay Service Agreement',
      readAgree: 'I have read and agreed',
      agreementTips: 'Please read and agree to the "OnerWay Service Agreement" first',
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      alreadyAccount: 'Already have an account',
      pleaseUploadPortraitSide: 'Please upload the portrait side of the legal representative\'s ID card',
      pleaseUploadNationalEmblemSide: 'Please upload the national emblem side of the legal representative\'s ID card',
      uploadImageTips: 'Make sure that the uploaded image is clear and visible, with a maximum size of 5M, and supports JPG, PNG, BMP, JPEG formats.',
      approving: 'Reviewing',
      passError: 'Sorry, the current review did not pass due to：',
      contactAddressTips: 'This address is mainly used for mailing related materials and filing certificates',
      updateRegisterInfo: 'Modify the registration materials',
      curApplyMerchant: 'The current application enterprise is {merchant}',
      globalMerchant: 'Group merchants',
      acquiringMerchant: 'Acquirers merchant',
      defaultMerchant: 'Default merchant',
      collectionMerchant: 'Collection merchant',
      payoutMerchant: 'Payouts merchant',
      quickRegistration: 'Quick registration',
      acquiringBusiness: 'Acquiring business',
      collectionsBusiness: 'Collections business',
      setDefaultMerchant: 'Set the default merchant',
      passwordErrorTip: 'Your password has been incorrect {errorNum} times, with {successNum} chances remaining',
      preventAccountLockingTip: ' Unable to avoid account locking, it is recommended to set a new password through "Forgot Password"',
      usernameOrPasswordError: 'Incorrect username or password',
      contactUs: 'Contact US',
      privacy: 'Legal & Privacy',
      privacy1: '"Legal & Privacy"',
      upgradeTitle: 'System upgrade - login address change',
      upgradeSubTitle1: 'Dear customer, due to the system upgrade, the original login address of the merchant terminal ',
      upgradeSubTitle2: 'will be offline',
      upgradeSubTitle3: 'Please log in with your new address：',
      upgradeDate: '',
      upgradeDate1: 'on October 1st',
      upgradeDesc1: 'The original login address：',
      upgradeDesc2: 'The new login address：',
      toNewLoginUrl: 'Jump to new address',
      payPassword: 'Payment Password',
      newPayPasswrod: 'New Payment Password',
      payPasswordTip: 'You can set a 6-digit numerical payment password and enter it when making a payment.',
      settingPayPasswordTip: 'Please enter your 6-digit numerical payment password and remember it; it will not be displayed again. If you forget it, you can reset it.',
      emailCode: 'Email Verification Code',
      emailCodeTip: 'Your registered email will receive a 6-digit verification code; enter it when making a payment.',
      phoneCode: 'Mobile Verification Code',
      resetPayPassword: 'Reset Payment Password',
      securityTitle: 'Payment Security Settings',
      securityDesc: 'Payment security for your account!',
      smsNoticeTitle: 'Notification',
      smsNoticeDesc: 'Alerts on account movements to keep track of financial changes',
      smsNoticeSwitch: 'Notification switch for recharge, payment, etc.',
      phoneNumber: 'Phone number',
      registerDoneDesc1: 'Congratulations! You have completed the registration',
      registerDoneDesc2: 'The page will jump to the login page after <span style="color:#00A2DD;">{second}</span>.',
      supplementDoneDesc1: 'Congratulations! You have finished submitting your identification information. We will review it for you as soon as possible.',
      supplementDoneDesc2: 'The page will return to the merchant side after <span style="color:#00A2DD;">{second}</span>.',
      certificateFileFront: 'Identity document - Front side',
      certificateFileReverse: 'Identity document - Back side',
      businessCertificateFile: 'Business Registration Certificate/Business Licence',
      businessOtherFile: 'Additional company documents',
      goSupplement: 'Go to improve',
      goRevise: 'Go to modify',
      goSupplementTips: 'Please complete the authentication information and try again',
      goReviseTips: 'Identity authentication failed, please modify',
      auditWaitingTips: 'Authentication audit, please wait',
      workAddress: 'Office Address',
      operationInfo: 'Operation Information',
      updatingFiles: 'Attachment Upload',
      businessCertificate: 'Business Proof',
      shareholder: 'Director',
      beneficiary: 'Beneficial owner',
      address: 'Address',
      webSite: 'Website address',
      webSitePlaceholder: 'Website address, you can add more than one, one per line',
      operationCountry: 'Country where the business primarily operates (multiple choice)',
      fundingSourceCountry: 'Country of funding source (multiple choice)',
      targetPaymentCountry: 'Target Payment Country (multiple choice)',
      monthlyAmount: 'Projected monthly transaction amount (in USD)',
      transactionAmount: 'Projected average single transaction amount (in USD)',
      bizDescription: 'Business Description',
      bizDescriptionPlaceholder: 'Please describe your business and operations, limit 200 words or less',
      saveTemporary: 'Temporary Saving',
      add: 'Add+',
      businessCertificationTips: 'Please upload complete business references',
      shareholderTips: 'Please upload complete director\'s certificates',
      beneficiaryTips: 'Please upload complete beneficiary documentation',
      authNotCompleted: 'Company authentication incomplete,',
      authNotFass: 'Face authentication rejected',
      autoNotPendding: 'Company authentication in review',
      jumioNotCompleted: 'Face authentication incomplete,',
      jumioNotCompletedNoicon: 'Face authentication incomplete',
      authReviewing: 'Identity authentication information, under review',
      authFailed: 'Authentication failed, ',
      fillInfo: 'fill in the authentication information',
      modifyInfo: 'Immediately modify',
      backMerchant: 'Return to home',
      saveTemporaryTips: 'Your changes have been successfully saved',
      stayPage: 'Stay on the current page',
      stayPageSupplement: 'Stay on this page',
      smsTips: 'Please select notification phone number or email.',
    },
    permission: {
      roleManagement: 'Role management',
      operatorManagement: 'Operator management',
      roleName: 'Role name',
      name: 'Name',
      role: 'Role',
      resetPassword: 'Reset password',
      deleteRoleConfirm: 'Confirm to delete this role',
      deleteUsedRoleConfirm: 'This role is still used by operators, confirm to delete this role',
      editRole: 'Edit role',
      addRole: 'Add role',
      rolePermission: 'Role permission',
      rolePermissionTip: 'If a button permission is not granted,' +
        ' the operator will be unable to click or interact with the button. ' +
        'Once permissions are assigned, the operator will gain visibility of the page and buttons,' +
        'along with the corresponding operations. ',
      addOperator: 'Add operator',
      addOperatorDesc: 'You can add operators to collaborate with you in managing payments',
      editOperator: 'Edit operator',
      password: 'Password',
      passwordRepeat: 'Confirm password',
      status: 'Status',
      permission: 'Permission',
      roleDetails: 'Role details',
      enableOperatorConfirm: 'Confirm enable operator',
      disableOperatorConfirm: 'Confirm to disable this operator',
      newPasword: 'New password',
      newPasswordConfirm: 'Confirm password',
      passwordConfirm: 'Confirm password',
      admin: 'Admin',
      receiveEmail: 'Receive email notifications',
    },
    common: {
      requestError: 'Request failed',
      blacklistOfSameTypeExist: 'Blacklist of same type exist, please add value directly. ',
      confirm: 'Confirm',
      clear: 'Clear',
      unneed: 'No need',
      edit: 'Edit',
      save: 'Save',
      enable: 'Enabled',
      disable: 'Disabled',
      enableOperation: 'enable',
      disableOperation: 'disable',
      enableOperationText: 'Enable',
      disableOperationText: 'Disable',
      prompt: 'Notice',
      promptsec: 'Changes saved',
      download: 'Download',
      add: 'Add',
      submit: 'Submit',
      back: 'Back',
      downloadTask: 'Download task has been created, please view it in download center',
      more: 'More',
      unlimited: 'Unlimited',
      noMatchText: 'No data found',
      noDataText: 'No data',
      showAll: 'View all information',
      optional: 'Optional',
      next: 'Next',
      previous: 'Previous',
      copySuccess: 'Copy success',
      reason: 'Reason',
      have: 'Have',
      none: 'None',
      profile: 'Profile',
      downloadTemplate: 'Download Template',
      finish: 'Finish',
      china: 'China',
      hk: 'Hong Kong',
      viewExamples: 'View examples',
      uploadFile: 'Please upload file',
      new: 'New',
      addData: 'Add',
      sort: 'Sort',
      deleteConfirm: 'Confirm deletion of this data',
      packUp: 'Fold',
      downloadReport: 'Download Report',
      disclaimer: 'Acquiring or fund collection business involved in this website, the funds outside mainland China will be collected by ONERWAY,' +
        ' while [NEWPAY] licensed in mainland China will be exclusively and directly in charge of the foreign exchange receipt and settlement in mainland China.' +
        ' ONERWAY shall not be held liable for any liability arising from and/or in relation to the services provided by NEWPAY in mainland China.',
      jumpNow: 'Jump Now',
      backNow: 'Return Now',
      city: 'City',
      province: 'State/Province',
      country: 'Country',
      zipCode: 'Postcode',
      close: 'Close',
      upload: 'Upload',
      first6Digits: 'First 6 digits',
      last4Digits: 'Last 4 digits',
      reset: 'Reset all',
      batchOperations: 'Batch operations',
      import: 'Import',
      copy: 'Copy',
      copied: 'Copied',
      dateOptions: {
        Y: 'Year',
        W: 'Week',
        M: 'Month',
        D: 'Day',
        H: 'Hour',
      },
      send: 'Send ',

    },
    cpQuery: {
      noArrayDataFound: 'No array data found',
      fetchDataError: 'Failed to fetch data',
    },
    validator: {
      required: 'Required',
      input: 'Please enter {input}',
      select: 'Please select {select}',
      confirm: 'Please confirm {confirm}',
      upload: 'Please upload {upload}',
      email: 'Please enter the correct email',
      passwordRule: 'Can only contain letters, numbers, characters (except spaces)',
      passwordLength: 'The length must be 8-20 characters',
      passwordStrength: 'Must contain numbers + characters + letters',
      passwordConfirm: 'It must be the same as the new password',
      newPasswordConfirm: 'Cannot be the same as the original password',
      passwordDiff: 'It must be the same as the password',
      stringLength256: 'The maximum input length is 256 characters',
      stringLength50: 'The maximum input length is 50 characters',
      fileCannot: 'File cannot be larger than',
      idCard: 'The ID number is incorrect',
      inputNumber: 'Please enter a number',
      cardLength: 'The length must be greater than 10 characters',
      inputWords: 'Can only contain letters, characters',
      inputEnglish: 'Only English letters (including upper and lower case), spaces, punctuation ( . and ,), numbers',
      inputPhone: 'The phone number is incorrect',
      count: 'Up to {count} order numbers are supported',
      inputLength: 'Length should be {length}',
      maxInputLength: 'The maximum input length is {length} characters',
      enNumberSpace: 'Only English letters, numbers, and spaces',
      formatError: 'Please enter the correct {field}',
      dateFormat: 'The format of the date of birth is incorrect',
      nameNotEqual: 'The company name and legal representative name are inconsistent',
      amount: 'It must be >= 0, and up to two decimal places are allowed',
      inputNumber1_100: 'Please enter a number between 1 and 100',
      amount_all: 'Only up to two decimal places are allowed',
      website: 'Please enter a valid URL',
      inputEmail: 'Please enter a valid email address',
      turWords: 'Only Turkish language is allowed',
    },
    transaction: {
      info: 'Transaction information',
      detail: 'Transaction details',
      billingAddress: 'Billing address',
      mailingAddress: 'Shopping address',
      integrationMethod: 'Integration method',
      name: 'Name',
      zipCode: 'Postal/Zip code',
      phone: 'Phone',
      city: 'City',
      thisTransion: 'This transaction',
      province: 'State/Province',
      country: 'Country',
      address: 'Address',
      mandatoryRefund: 'Refund',
      maximumRefundAmount: 'Maximum refund amount',
      maximumRefundAmountText: 'The current refund amount has exceeded the maximum refundable amount of {amount} (including historical refunds). Please check and resubmit.',
      validateRefundAmount: 'The amount format is incorrect. Please enter only numeric values.',
      requestRefundAmount: 'Request refund amount',
      eciHint: '<div>\n <h3 style="font-size:12px;margin-bottom:8px">ECI:</h3>\n <p>ECI=00: MasterCard used. <br>ACS service is not available or the card does not support 3D verification;</p>\n ' +
        ' <p>ECI=01: MasterCard used. <br>The cardholder or the issuer is not registered for the 3D security verification service;</p>\n' +
        ' <p>ECI=02: MasterCard used. <br>Cardholder 3D security verification passed;</p>\n ' +
        ' <p>ECI=05: Visa used. <br>Cardholder 3D security verification passed;</p>\n ' +
        '<p>ECI=06: Visa used. <br>The cardholder or issuer is not registered for the 3D security verification service;</p>\n ' +
        ' <p>ECI=07: Visa used. <br>ACS service is not available or the card does not support 3D verification. </p>\n </div>',
      uploadProgress: 'Upload progress',
      uploadLogisticsNo: 'Upload tracking number',
      uploadLogisticsNoTemplate: 'Upload_tracking_number',
      uploadDetails: 'Upload details',
      isUploadLogistics: 'Whether to upload tracking number',
      logisticsNo: 'Tracking number',
      logisticsProvider: 'Carrier',
      batchQuery: 'Batch inquery',
      batchQueryTemplate: 'Batch_inquery',
      batchRefund: 'Batch refund',
      batchRefundTemplate: 'Batch_refund',
      paymentStatus: 'User payment status',
      refundAmountInt: 'When the refund currency is JPY, the amount must be an integer',
      download: 'Download Statement',
      dividendStatus: 'Status',
      dividendDetailsNo: 'Share details number',
      dividendTxnSerialNo: 'Detailed order number',
      dividendReceivingAccount: 'Receiver account',
      describes: 'Description',
      notifyUrl: 'Notification address',
      refundDetail: 'Refund details',
      refundInfo: 'Refund details',
      refundArn: 'Refund ARN',
      originTxnId: 'Transaction ID',
      customerEmail: 'Customer email',
      transactionURL: 'Transaction URL',
      paymentSuccessTime: 'Payment success time',
      refundProcessTime: 'Refund execution time',
      refundRespCode: 'Refund response code',
      refundRespMsg: 'Refund response msg',
      advise: 'Advise',
      refundReceipt: 'Refund receipt',
      refundStatus: 'Refund status',
      txnProcessTime: 'Execution time',
      timeline: 'Timeline',
      paymentDetails: 'Payment details',
      threeDS: '3D-Secure',
      riskDetails: 'Risk details',
      merchantDetails: 'Merchant details',
      redirectedCard3DS: 'Redirected：3D Secure',
      redirectedLocal: 'Redirected：Local payment method',
      paymentRespCode: 'Payment response code',
      paymentRespMsg: 'Payment response msg',
      refundArnTips: '<p style="color:#9EA9C1;margin-bottom:8px">Refund ARN</p>' +
        'An Acquirer Reference Number (ARN) is a unique number assigned to a credit card transaction as it moves through the payment flow. ' +
        'It can be used by banks to help trace your refund if it appears to be missing. ' +
        'An ARN will be available only for supported card networks, and marked as unavailable otherwise.',
      refundSuccessDesc: 'Refund succeeded {desc1}（{desc2}）',
      paymentFailDesc: 'Payment failed: {desc}',
      respCodeList: 'Full list of response code',
      clickNumViewDetails: 'You can click on the order number to view details',
      retryTransaction: 'retry transaction',
      expandAll: 'Expand all',
      channelRequestId: 'Transaction request ID',
      channelRequestIdTooltip: 'Channel Request ID is a unique identifier generated by the payment system to track and identify the status of a transaction request in the payment channel.',
      // 渠道响应ID
      channelResponseId: 'Channel Response Number',
      channelResponseIdTooltip: 'Channel Response Number is a unique identifier assigned to a payment request by the bank. It is used to track and identify the status of a payment request in the payment channel.',
      receivedFraudNotification: 'Received Fraud Notification',
      preDispute: 'Pre-dispute',
      contractNumber: 'Contract number',
      initialPurchase: 'Initial purchase?',
    },
    settlement: {
      currency: 'Settlement currency',
      management: 'Settlement',
      batchManagement: 'Settlement batch',
      time: 'Settlement date',
      batchNo: 'Settlement batch ID',
      batchProcessingDate: 'Settlement running batch date',
      txnAmount: 'Transaction amount',
      processingAmount: 'Processing amount',
      refundAmount: 'Refund amount',
      refuseAmount: 'Chargeback amount',
      refuseProcessingAmount: 'Chargeback processing fee',
      txnProcessingAmount: 'Transaction processing fee',
      refundProcessingAmount: 'Refund processing fee',
      txnFeeAmount: 'Merchant discount rate',
      settlementAmount: 'Settlement amount',
      settlementStatus: 'Settlement status',
      disbursementTime: 'Payment time',
      detailsManagement: 'Billing details management',
      orderNo: 'Transaction order number',
      createdAt: 'Order generation time',
      txnTime: 'Transaction time',
      txnCompleteTime: 'Transaction completion time',
      orderAmount: 'Order Amount',
      // 结算币种金额
      settlementCurrencyAmount: 'Settlement currency amount ',
      handlingAmount: 'Processing fee',
      serviceAmount: 'Merchant discount rate',
      payoutAmount: 'Fee',
      recalculate: 'Recalculate',
      atLeastOneDetail: 'At least one settlement detail',
      recalculateConfirm: 'Confirm to recalculate',
      reRunBatch: 'Rerun batch',
      reRunBatchConfirm: 'Confirm to run the batch again',
      deposit: 'Risk deposit collection',
      marginRelease: 'Margin release',
      feeStatus: 'Billing status',
      accountDetails: 'Balance details',
      accountTxnType: 'Account transaction type',
      accountTxnTime: 'Account transaction time',
      changeAmount: 'Change amount',
      accountBalance: 'Account balance',
      accountTotalAmount: 'Total amount',
      pendingSettledAmount: 'Amount to be settled',
      frozenAmount: 'Frozen amount',
      marginAmount: 'Margin amount',
      availableBalance: 'Available balance',
      frozenAct: 'Frozen accounts',
      availableBalanceAct: 'Available balance accounts',
      refundsRevokeConfirm: 'A revocation operation is currently in progress. After confirmation, it means that the refund has been revoked. Do you want to confirm? ',
      currencyViewed: 'Please select the currency to view',
      depositReleaseAmt: 'Risk deposit release',
      restoreDetaileddeclaration: 'Restore detailed declaration',
      uploadFile: 'Upload files',
      templateDownload: 'Template download (.xlsx)',
      restoreDetaileddeclarationNumber: 'Serial number',
      count: 'Total number',
      successCount: 'Number of successful transactions',
      failedCount: 'Number of failed transactions',
      fileName: 'File name',
      export: 'Export',
      downloadFailedFile: 'Download failed file',
      disbursementNo: 'Payment serial number',
      disbursementCreatedAt: 'Creation time',
      disbursementAt: 'Payment time',
      disbursementStatus: 'Payment status',
      rate: 'Exchange rate',
      disbursementCurrency: 'Withdrawal currency',
      disbursementAmt: 'Disbursement amount',
      payee: 'Payee',
      disbursementServiceCharge: 'Withdrawal fee',
      ortherExpenses: 'Other expenses',
      disbursementDescription: 'Payment description',
      exportSettlementDetail: 'Export settlement details',
      appId: 'APPID',
      transactionUrl: 'Transaction URL',
      searchTimeTip: 'Please select a settlement date or transaction time',
      restoreDescription: `For withdrawal, you need to provide a restore order. Please download the "template", fill in the restore order and upload it.
      If the order you submitted reports an error, you can modify it and upload it again`,
      capabilities: 'Our account capabilities',
      sources: 'sources',
      batch: 'Settlement batch',
      details: 'Settlement details',
      frozenAmountTips: 'Amount during transfer or frozen due to risk control',
      decisionManagementFee: 'Risk management fee',
    },
    payee: {
      bankName: 'Bank name',
      identificationNumber: 'ID number',
      gender: 'Sex',
      cardNumber: 'Bank account number',
      creationTime: 'Creation time',
      birthday: 'Birthday',
      namePinyin: 'Name Pinyin',
      effectiveDate: 'Effective date',
      expireDate: 'Expiration date',
      nationality: 'Nationality',
      occupation: 'Occupation',
      bankAddress: 'Account opening bank address',
      readAgree: 'I have read and agree',
      idPhoto: 'ID photo',
      frontPhoto: 'ID card (front photo)',
      reversePhoto: 'ID card (reverse photo)',
      customerAgreement: '"Customer service agreement"',
      customerAgreementTitle: 'Customer service agreement',
      male: 'Male',
      female: 'Female',
      illegalValidityTips: 'The validity period of the certificate is incorrect',
      selectProvince: 'Please select a province',
      selectCity: 'Please select a city',
      bankAccount: 'Bank Account',
      mobilePhone: 'Mobile phone number',
      frontPhotoTips: 'Please upload ID card (front photo)',
      reversePhotoTips: 'Please upload ID card (reverse photo)',
      essentialInformation: 'Essential information:',
      payeeAccount: 'Payee account:',
      addPayeeAccountInfo: 'Add payee information',
      seePayeeAccountInfo: 'View payee information',
      customerAgreementTips: 'Please read the customer service agreement',
      distributableQuota: 'Distributable amount',
      addPayee: 'Add payee',
      payeeFileTip: 'Only upload jpg,jpeg,png files',
      legalPerson: 'Enterprise person in charge',
      selfPerson: 'Wholesale and retail industry self-employed',
      liberalProfessions: 'Freelancer',
      longEffectiveness: 'Indefinitely',
      canAddedAgain: 'After the payee is authenticated successfully, it can be added again',
      makeItDefault: 'Do you want to make it the default',
    },
    contact: {
      contact: 'Payee',
      addContact: 'Add payee',
      editContact: 'Edit payee',
      beneficiaryCategory: 'The account belongs to',
      beneficiaryType: 'Business type',
      accountCurrency: 'Account currency',
      bankCountryRegion: 'Country/region of beneficiary bank',
      paymentMethod: 'Payment method',
      beneficiaryName: 'Name',
      certificateNo: 'ID number/organization code',
      beneficiaryCountry: 'Payee country',
      beneficiaryAddress: 'Payee address',
      accountName: 'Bank account name',
      bankName: 'Bank name',
      accountNumber: 'Bank account number',
      swiftCode: 'Swift/Bic code',
      sortCode: 'Sort code',
      file: 'File',
      own: 'Own',
      others: 'Others',
      individual: 'Individual',
      enterprise: 'Corporate',
      business: 'Company',
      downloadMaterial: 'Download',
      setDefault: 'Set the default withdrawal account',
      transferMoney: 'Payment',
      defaultAccount: 'Default withdrawal account',
      mobilePhone: 'Phone',
      localDescription: 'A relatively cheap payment method that only supports the local currency of the beneficiary bank country',
      swiftDescription: 'Usually more expensive and supports a wider range of payments',
      fileTips: '*The first owned card will automatically be used as the withdrawal card, at this time you need to upload the merchant contract',
      vat: 'VAT payment',
      vatFile: 'VAT tax documents',
      saveContact: 'Save Recipient',
      contactId: 'Beneficiary ID',
      walletPhone: 'Account Identifier',
      payeePhone: 'Recipient\'s phone',
      pickUpBank: 'Payer',
      branchName: 'Payer branch',
      bankBranchName: 'Branch name',
      bankBranchAddress: 'Address',
      pickUpBankAddress: 'Payer branch address',
      tfPin: 'TfPin',
      nickname: 'Nickname',
      acType: 'Account Type',
      bankCode: 'Bank Code',
      branchCode: 'Branch Number',
      routingNumber: 'Routing Number',
      walletType: 'Wallet Information',
      address: 'Address',
      addressPlaceholder1: 'Address1',
      addressPlaceholder2: 'Address2（Optional）',
      addressPlaceholder3: 'Address3（Optional）',
      zipCode: 'ZipCode',
      state: 'State',
      city: 'City',
      birthDate: 'Birthdate',
      transferTo: 'Account location',
      accountBank: 'Bank Account',
      swiftTitle: 'SWIFT',
      accountWallet: 'Wallet',
      accountCash: 'Cash pickup',
      firstName: 'FirstName',
      lastName: 'LastName',
      companyName: 'CompanyName',
      jpNameTips: 'When making a payment to Japan, only Latin is allowed in the name, otherwise the payment may be failed.',
      swiftCodeInputTitle: 'Search by SWIFT CODE or bank name',
      atLeast3SwiftCodeTips: 'Please enter at least 3 digits of the code in order to search for results.',
      swiftCodeInputTips: 'Please input the swift code or bank name to search',
      payeeTips: 'Used to distinguish between payees, no duplication allowed.',
      bankCodeTips: 'Please fill in the bank code such as Sort Code / ABA Routing Number.',
      bankHolderNameTip: 'Payment to the Indonesian company, the bank account name must be ensured to be the same as the bank registration, otherwise the payment may be failed.',
      identificationNumber: 'Identification number',
      organizationCode: 'Organization code certificate',
      payerNameTips: 'Bank transfers to the UK and Europe support displaying the Payer name that has been verified by the Onerway platform, appearing as the beneficiary-visible remitter name. If left blank, payments will be processed using the default remitter identity.',

      accountLabeltips: 'Please provide the wallet identifier corresponding to your digital wallet. For example, PayPal-Email, GCash-Phone number',
    },
    account: {
      info: 'Account information',
      loginEmail: 'Sign in email',
      contactEmail: 'Contact email',
      registrationTime: 'Registration time',
      merchantNo: 'Merchant number',
      merchantName: 'Merchant name',
      customEmail: 'Customer Email',
    },
    application: {
      addApp: 'Create application',
      appNameTip: 'Please enter the application name',
      appTypeTip: 'Please select an application type',
      appWebsiteTip: 'Please enter the application url',
      addYourApplication: 'Add your application',
      addAppTitle: 'Your application is here!',
      addAppDescription: 'Here is your application list, and you can start trading after it takes effect.',
      nameAndId: 'Application name；Application ID',
      myApp: 'My Application',
      newWebsiteApp: 'New website application',
      newWebsiteAppDes: 'Please create a site according to the following information, and we will process the site information you submit within 24 hours.',
      appNameErrorTips: 'Please limit your merchant name to 64 characters (or 32 Chinese characters) or less',
      appType: 'Website Type',
      merchantName: 'Store Name',
      aliExpressAccount: 'AliExpress account',
      aliExpressEntityName: 'The name of the registered entity of AliExpress',
      aliExpressMerchantUrl: 'The URL of AliExpress',
      site: 'Main site',
      applyChannelEmail: 'Store email',
      storeUrl: 'Store URL',
      paypalEmail: 'PayPal account mailbox',
      paypalMerInfo: 'PayPal merchant information',
      paypalMerAccount: 'PayPal merchant account',
      paypalUserInfo: 'PayPal user information',
      salesCategory: 'Sales Category',
      expectedAnnualSales: 'Estimated annual sales volume',
      websiteUrl: 'Website URL',
      otherMaterial: 'Other Information',
      paypalScreenshot: 'PayPal screenshot',
      ownershipFile: 'Store Attribution Proof Document',
      sellId: 'Seller number',
      amazonHolderNameTip: 'Must be consistent with the name of the main company registered with Amazon, otherwise it will affect the funds credited',
      createTime: 'Store creation time',
      id: 'Store ID',
      websiteType: 'Store type',
      auditStatus: 'Store audit status',
      edit: 'Modify store information',
    },
    refuse: {
      arn: 'Chargeback ARN',
      status: 'Chargeback status',
      enterTime: 'Chargeback entry time',
      sourceType: 'Chargeback source type',
      date: 'Date of chargeback',
      disputeDueDate: 'Rebuttal due date',
      code: 'Chargeback code',
      reason: 'Reason for chargeback',
      revoke: 'Revocation of chargeback',
      appealMaterials: 'Required rebuttal documents',
      agentStatus: 'Agent status',
      appealStatus: 'Rebuttal status',
      appealDetails: 'Rebuttal details',
      appealAudit: 'Rebuttal audit',
      appealCountdown: 'Days left to response',
      appealWrittenDescription: 'Rebuttal description',
      appealFile: 'Rebuttal documents',
      appealFileOptional: 'Rebuttal document(optional) ',
      appealFileTemplate: 'Rebuttal template',
      submitMaterials: 'Submit rebuttal documents',
      submitMaterialsEndTime: 'Document submission deadline',
      refundInformation: 'Refund information',
      refuseFileTip: 'Only upload .pdf files',
      refuseFileImageTip: 'Only jepg and tiff files are accepted',
      refuseAppealExplainTip: 'Please enter a rebuttal description',
      refuseAppealDataTip: 'Please upload rebuttal documents',
      refuseAcceptTips: 'Accept chargeback is currently in progress, do you want to confirm? ',
      details: 'Chargeback details',
      chargebackAlert: 'Chargeback alert',
      secondAppealConfirm: 'Confirm to proceed with second rebuttal?',
      secondAppealConfirmTips: 'If the second rebuttal fails, a penalty of approximately $500 will be charged, with the exact amount subject to actual collection.',
      refuseId: 'Chargeback ID',
      refuseInfo: 'Chargeback details',
      receivedTime: 'Received time',
      viewRebuttal: 'View rebuttal',
      daysLeftToResponse: 'Days left to response',
      expired: 'expired',
      quickFilterReceived: 'Chargeback received',
      quickFilterRebuttal: 'In Rebuttal',
      quickFilterAll: 'All chargebacks',
      quickFilterWon: 'Won',
      quickFilterLoss: 'Loss',
      quickFilterClosed: 'Closed',
      dueDate: 'Chargeback due date',
      klarnaRebutDrawer: {
        continueRebut: 'Continue rebuttal',
        title: 'Submit dispute evidence',
        saveDraft: 'Save draft',
        nextStep: 'Next',
        prevStep: 'Prev',
        submit: 'Submit',
        chargeInfoTitle: 'Chargeback info',
        chargeInfoDate: 'Chargeback date',
        chargeInfoDeadline: 'Response deadline',
        chargeInfoAmount: 'Chargeback amount',
        chargeInfoReason: 'Chargeback reason',
        chargeInfoMethod: 'Payment method',
        stepOneTitle: 'Step one. Two steps',
        stepTwoTitle: 'Step two. Two steps',
        fillRebuttalTitle: 'Fill in rebuttal details',
        fillRebuttalTitleTwo: 'Upload supporting documents',
        fillRebuttalDesc: "Providing as much detailed rebuttal information as possible helps us gather more evidence to counter the cardholder's claims. Fields are mandatory unless marked as optional.",
        fillRebuttalDescTwo: 'Only PDF files are supported, with English content (images like Chinese logistics details allowed). Upload up to 3 files per section, each under 2MB.',
        productFormTitle: 'Product details',
        productFormWebsite: 'Shopping website',
        productFormTerms: 'Shopping terms',
        productFormDesc: 'Product name and pre-sale description',
        productFormWebsitePlaceholder: 'Please enter a live URL.',
        productFormTermsPlaceholder: 'Please enter refund and shipping-related terms or link.',
        uploadTips: 'Upload image click here or Drag & Drop',

        transaction: {
          title: 'Transaction details',
          transactionId: 'Transaction ID',
          orderId: 'Merchant order ID',
          time: 'Transaction time',
          ip: 'IP',
          userAgent: 'User agent',
          tableTitle: 'Refund information',
        },

        customer: {
          title: 'Customer details',
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          phone: 'Phone number',
          addressTitle: 'Billing address',
        },

        address: {
          city: 'City',
          state: 'State',
          country: 'Country',
          postalCode: 'Postal code',
          line1Placeholder: 'Enter street address and house number',
          line2Placeholder: '(Optional) Add additional details, such as floor or unit number',
        },

        shipping: {
          title: 'Shipping details',
          goodType: 'Type of Good',
          trackingNumber: 'Tracking number',
          trackingNumberPlaceHolder: 'Recommend entering the delivery tracking number.',
          firstName: 'First name',
          lastName: 'Last name',
          phone: 'Phone number',
          addressTitle: 'Shipping address',
        },

        appealReply: {
          title: 'Reply to chargeback',
          appealExplain: 'Rebuttal statement',
          placeholder: 'English is recommended ',
        },

        shippingUpload: {
          title: 'Upload shipping documents',
          physicalTips: 'Recommended to upload proof of delivery and other shipping evidence.',
          intangibleTips: 'e.g. email delivery, login data',
          pickUpTips: "Proof must include the customer's name, pickup date and time, and product list; or provide a pickup power of attorney with at least 9 months of retention.",
        },

        otherUpload: {
          title: 'Upload other documents',
          fileTypePlaceholder: 'Select document type',
          tooltips: 'e.g., a copy of the conversation, etc.',
        },

        leave: {
          title: 'Unsaved Information',
          content: 'Exiting will clear all data. Save your progress before leaving?',
          confirmText: 'Exit',
          cancelText: 'Continue editing',
        },

        downloadAll: 'Download all',
        uploadErrorMessage: 'Please upload the document',
        uploadErrorMessage1: 'Please select the ducument type',
        uploadErrorMessage2: 'You can upload up to 3 files of the same document',

      },
    },
    dispute: {
      appealFileTime: 'Upload time',
      appealFileName: 'Rebuttal document name',
      englishOnly: '(English is recommended)',
      fileUploadFormatSupplement: 'When supplementing rebuttal documents, only new materials can be submitted; modifications or deletions of already submitted materials are not allowed.',
      fileUploadFormat: 'Only PDF format is supported. The PDF content must be in English (except for image content, such as Chinese logistics information).' +
        'You can upload a maximum of 10 files at a time, with each file up to 2MB. It is recommended to consolidate all rebuttal materials into a single PDF document.',
      discoverFileUploadFormat: 'Only TIFF and JPEG format is supported. The content must be in English. You can upload a maximum of 10' +
        ' files at a time, with each file up to 5MB. Please upload images that include: order details, shipping proof, payment information, product description, or communication records.',
      explain0: 'Uncommon reason. ',
      explainAnswer0: 'Please consult the account manager or other staff. ',
      explain1: 'The cardholder participated in the transaction, but the cardholder or an authorized person did not receive the goods or services because the merchant was ' +
        'unwilling or unable to provide the goods or services.',
      explainAnswer1: 'Provide documentation to prove that the cardholder or an authorized person received the goods or services at the agreed location or by the agreed daten' +
        '\nIf the goods or services are in transit, provide tracking information and evidence that shows the delivery was carried out in a prompt manner.',
      explain2: 'The cardholder withdrew permission to charge the account for a recurring transaction or, in the Europe Region, an installment transaction (All Regions)  or membership fee.' +
        '\nCancelled the card account.',
      explainAnswer2: ' Provide documentation to prove that the service was not cancelled or to show that neither you nor the acquirer were notified that the account was closed. ' +
        'In all regions excluding Europe, you may also provide documentation to prove that the transaction was not previously charged back.',
      explain3: 'Either the goods or services did not match what was described on the transaction receipt or other documentation presented at the time of purchase. ' +
        'OR The merchandise received by the cardholder was damaged or defective (All excluding France Domestic). ' +
        'OR The cardholder disputes the quality of the goods or services (All excluding France Domestic).  ',
      explainAnswer3: 'You need to provide documentation to prove that the goods or service matched what was described, a rebuttal addressing the cardholder\'s claims, and if applicable, ' +
        'documentation to prove that the cardholder did not attempt to return the merchandise.',
      explain4: 'The cardholder claims that the purchased merchandise was counterfeit.',
      explainAnswer4: 'Provide proof that the purchased merchandise is authentic, and that the cardholder knew of its quality during the transaction.',
      explain5: 'The cardholder claims the purchased good/service was misrepresented during the transaction. ' +
        'Examples include false advertisement and a merchant falsifying the quality of the purchased good/service.',
      explainAnswer5: ' Provide proof that all representation of purchased good/service was, and is, accurate during the transaction.',
      explain6: 'The cardholder received a credit or voided transaction receipt that was not processed (Europe and Interregional including Europe). ' +
        'OR The cardholder cancelled or returned merchandise, cancelled services, cancelled a timeshare transaction, ' +
        'or cancelled a Guaranteed Reservation and the merchant did not process a credit or voided transaction receipt. ' +
        'And, either the merchant did not properly disclose or did disclose, but did not apply, a limited return or cancellation policy at the time of the transaction, or in the Europe Region, ' +
        'the merchandise or services relate to an off-premises, distance selling contract (as set out in the EU Directive and amended from time to time) which is always subject to a 14-day ' +
        'cancellation period. (All Regions). OR An original credit transaction was not accepted because either: the recipient refused the original credit transaction, ' +
        'or original credit transactions are prohibited by applicable laws or regulations.',
      explainAnswer6: 'You need to provide either the transaction receipt or other records to prove that the merchant properly disclosed a limited return ' +
        'or cancellation policy at the time of the transaction, or evidence to demonstrate that the cardholder received the merchant\'s cancellation or return policy and did not cancel according ' +
        'to the disclosed policy.',
      explain7: 'The cardholder claims that the merchant had charged him or her for a merchandise/service that was cancelled.',
      explainAnswer7: 'Provide proof that the disputed transaction was not cancelled, and that the cardholder did not give any demand to cancel said transaction.',
      explain8: 'The cardholder contacted their issuer to dispute a purchase. This can be for a variety of reasons, such as non-receipt or damaged/defective merchandise. For full details, ' +
        'see applicable modifiers. An issuer may continue to use reason code 4841, 4855, 4859, and 4860, however, 4841, 4855, 4859, ' +
        'and 4860 will eventually be eliminated as valid message reason codes.',
      explainAnswer8: 'This chargeback may be reversed by supplying proof that the cardholder received the goods which fit the description at the time of the purchase. ' +
        'Specific compelling evidence based on applicable modifiers can be found in the modifiers section.',
      explain9: 'The cardholder claims they have paid for an item that was to be delivered, but has not yet been received.',
      explainAnswer9: 'Provide documentation to prove that the cardholder or an authorized person received the goods or services at the agreed location or by the agreed date.\n' +
        'If the goods or services are in transit, provide tracking information and evidence that shows the delivery was carried out in a prompt manner.',
      explain10: 'The cardholder claims they are due a credit from an establishment that has not been processed.',
      explainAnswer10: 'In your response, you need to either show that the merchandise was never returned, that the cancellation was not accepted, or that a credit or a reversal was processed.',
      explain11: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer11: 'Respond to this dispute with evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized.',
      explain12: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer12: 'Respond to this dispute with evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized.',
      explain13: 'The cardholder states that neither he, she, nor anyone authorized by him or her engaged in the transaction.',
      explainAnswer13: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      explain14: 'The cardholder or authorized user was still in possession and control of all valid cards at the time of the transaction, ' +
        'and the cardholder admits to at least one legitimate face-to-face transaction, on the same card at a given merchant location, ' +
        'but denies making one or more additional face-to-face transactions at that same merchant location.',
      explainAnswer14: 'Respond to the dispute by providing documentation substantiating the cardholder participated in the original transaction and ' +
        'documentation to establish the cardholder is responsible for the additional transaction(s). Proof of card presence and signature for the original transaction, ' +
        'as well as documentation to support that the addendum transaction is the cardholder’s responsibility is important.',
      explain15: 'Cardholder or merchant involved in fraud investigation',
      explainAnswer15: 'Respond to the dispute by providing documentation substantiating the cardholder participated in the original transaction and ' +
        'documentation to establish the cardholder is responsible for the additional transaction(s). Proof of card presence and signature for the original transaction, ' +
        'as well as documentation to support that the addendum transaction is the cardholder’s responsibility is important.',
      // explain16: 'This chargeback involves the use of an incorrect transaction code. Examples include the merchant receiving the wrong API to complete the transaction.',
      // explainAnswer16: 'Provide transactional data from the payment processor and gateway in order to show the transaction code is correct.',
      explain17: 'The cardholder disputes the validity of the adjustment because of the adjustment amount or because the original transaction was cancelled or reversed (US Domestic).',
      explainAnswer17: 'Provide the original transaction date and the trace number.',
      explain18: 'A single transaction was processed more than once using the same account number. OR the cardholder paid for the same merchandise or service by other means.',
      explainAnswer18: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
        'OR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      explain19: 'A single transaction was processed more than once using the same account number because of the processing error.',
      explainAnswer19: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
        'OR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      explain20: 'The cardholder claims that the amount they agreed to pay differs from the amount charged.',
      explainAnswer20: 'Respond to this chargeback by providing documentation and a written explanation showing two separate transactions were correctly processed. ' +
        'If this is an unreasonable amount dispute, provide documentation showing that the cardholder agreed to an amount range as reasonable and that the transaction did not exceed this amount range.',
      explain21: 'one of the following:\n ' +
        'The cardholder paid twice for the same transaction using two different forms of payment.\n ' +
        'The cardholder’s account has been debited more than once for the same transaction using the same form of payment',
      explainAnswer21: 'Your response to this chargeback can include evidence that both transactions were valid and were authorized by PIN, ' +
        'a credit was issued, documentation indicating the two separate transactions and that they were valid, ' +
        'or that the chargeback is invalid because the issuer failed to provide the original ARD in DE 72 (Data Record).',
      // explain22: 'The cardholder claims they were in possession of a valid card on the date of transaction or they did not authorize or participate in the transaction. \n' +
      // 'The card is no longer, or has never been, in the possession of the cardholder.',
      // explainAnswer22: 'Respond with evidence showing that the liability shift does not apply by providing documentation ' +
      // 'displaying the card involved was not a hybrid card according to the service ' +
      // 'code (DE 35 or DE 45) in the authorization request (that is, the value of the first position was not a 2 or a 6), the transaction was completed with chip, ' +
      // 'or the chargeback was otherwise invalid (for example, the terminal was a hybrid).',
      explain23: 'The cardholder can not sure that he,she, nor anyone authorized by him engaged in the transaction.',
      explainAnswer23: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      explain24: 'The cardholder can not sure that he,she, nor anyone authorized by him engaged in the transaction.',
      explainAnswer24: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      // explain25: 'The cardholder can not sure that he,she, nor anyone authorized by him engaged in the transaction.',
      // explainAnswer25: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
      // 'or an authorized user, participated in the transaction.',
      explain26: 'The cardholder can not sure that he,she, nor anyone authorized by him engaged in the transaction.',
      explainAnswer26: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      // explain27: 'A transaction where authorization was required, but not obtained. It can also occur for transactions where the primary account number (PAN) does not exist. ',
      // explainAnswer27: 'Prove the transaction was presented within seven calendar days of the pre-authorization or authorization approval date and the pre-authorization or ' +
      // 'authorization was not reversed. You can also provide evidence that the issuer has not permanently closed the account or to prove that the transaction was either approved ' +
      // 'online by the issuer or offline by the chip.',
      explain28: 'This chargeback involves the use of an incorrect transaction code. Examples include the merchant receiving the wrong API to complete the transaction.',
      explainAnswer28: 'Provide transactional data from the payment processor and gateway in order to show the transaction code is correct.',
      // explain29: '发卡行拒绝核准该交易',
      // explainAnswer29: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
      // 'or an authorized user, participated in the transaction.',
      // explain30: '交易传递出现延误',
      // explainAnswer30: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
      // 'or an authorized user, participated in the transaction.',
      explain31: 'A single transaction was processed more than once using the same account number. OR the cardholder paid for the same merchandise or service by other means.',
      explainAnswer31: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
        'OR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      // explain32: 'The cardholder disputes the validity of the adjustment because of the adjustment amount or because the original transaction was cancelled or reversed (US Domestic).',
      // explainAnswer32: 'Provide the original transaction date and the trace number.',
      // explain33: 'The cardholder disputes the validity of the adjustment because of the adjustment amount or because the original transaction was cancelled or reversed (US Domestic).',
      // explainAnswer33: 'Provide the original transaction date and the trace number.',
      explain34: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer34: 'Respond to this dispute with evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized.        ',
      explain35: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer35: 'Respond to this dispute with evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized.',
      // explain36: 'A single transaction was processed more than once using the same account number. OR the cardholder paid for the same merchandise or service by other means.',
      // explainAnswer36: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
      // 'OR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      // explain37: '持卡人信息被盗用',
      // explainAnswer37: 'Respond to the dispute by providing documentation substantiating the cardholder participated in the original transaction and ' +
      // 'documentation to establish the cardholder is responsible for the additional transaction(s). Proof of card presence and signature for the original transaction, ' +
      // 'as well as documentation to support that the addendum transaction is the cardholder’s responsibility is important.',
      explain38: 'This chargeback involves the use of an incorrect transaction code. Examples include the merchant receiving the wrong API to complete the transaction.',
      explainAnswer38: 'Provide transactional data from the payment processor and gateway in order to show the transaction code is correct.',
      explain39: 'The cardholder claims they were in possession of a valid card on the date of transaction or they did not authorize or participate in the transaction. \n' +
        'The card is no longer, or has never been, in the possession of the cardholder.',
      explainAnswer39: 'Respond with evidence showing that the liability shift does not apply by providing documentation displaying the card involved was not a hybrid card according to the service ' +
        'code (DE 35 or DE 45) in the authorization request (that is, the value of the first position was not a 2 or a 6), the transaction was completed with chip, ' +
        'or the chargeback was otherwise invalid (for example, the terminal was a hybrid).',
      explain40: 'The cardholder claims they were in possession of a valid card on the date of transaction or they did not authorize or participate in the transaction. \n' +
        'The card is no longer, or has never been, in the possession of the cardholder.',
      explainAnswer40: 'Respond with evidence showing that the liability shift does not apply by providing documentation displaying the card involved was not a hybrid card according to the service ' +
        'code (DE 35 or DE 45) in the authorization request (that is, the value of the first position was not a 2 or a 6), the transaction was completed with chip, ' +
        'or the chargeback was otherwise invalid (for example, the terminal was a hybrid).',
      explain41: 'The cardholder disputes the validity of the adjustment because of the adjustment amount or because the original transaction was cancelled or reversed (US Domestic).',
      explainAnswer41: 'Provide the original transaction date and the trace number.',
      explain42: 'The cardholder participated in the transaction, but the cardholder or an authorized person did not receive the goods or services because the merchant was ' +
        'unwilling or unable to provide the goods or services.',
      explainAnswer42: 'Provide documentation to prove that the cardholder or an authorized person received the goods or services at the agreed location or by the agreed date.' +
        '\nIf the goods or services are in transit, provide tracking information and evidence that shows the delivery was carried out in a prompt manner.',
      explain43: 'This chargeback involves the use of an incorrect transaction code. Examples include the merchant receiving the wrong API to complete the transaction.',
      explainAnswer43: 'Provide transactional data from the payment processor and gateway in order to show the transaction code is correct.',
      explain44: 'The cardholder claims they are due a credit from an establishment that has not been processed.',
      explainAnswer44: 'In your response, you need to either show that the merchandise was never returned, that the cancellation was not accepted, or that a credit or a reversal was processed.',
      explain45: 'A single transaction was processed more than once using the same account number. OR the cardholder paid for the same merchandise or service by other means.',
      explainAnswer45: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
        'OR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      explain46: 'The cardholder withdrew permission to charge the account for a recurring transaction or, in the Europe Region, an installment transaction (All Regions)  or membership fee.' +
        '\nCancelled the card account.',
      explainAnswer46: ' Provide documentation to prove that the service was not cancelled or to show that neither you nor the acquirer were notified that the account was closed. ' +
        'In all regions excluding Europe, you may also provide documentation to prove that the transaction was not previously charged back.',
      explain47: 'The cardholder states that neither he, she, nor anyone authorized by him or her engaged in the transaction.',
      explainAnswer47: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      explain48: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer48: 'Respond to this dispute with evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized. ',
      explain49: 'The cardholder participated in the transaction, but the cardholder or an authorized person did not receive the goods or services because the merchant was ' +
        'unwilling or unable to provide the goods or services.',
      explainAnswer49: 'Provide documentation to prove that the cardholder or an authorized person received the goods or services at the agreed location or by the agreed date.' +
        '\nIf the goods or services are in transit, provide tracking information and evidence that shows the delivery was carried out in a prompt manner.',
      explain50: 'Either the goods or services did not match what was described on the transaction receipt or other documentation presented at the time of purchase. ' +
        'OR The merchandise received by the cardholder was damaged or defective (All excluding France Domestic). ' +
        'OR The cardholder disputes the quality of the goods or services (All excluding France Domestic).  ',
      explainAnswer50: 'You need to provide documentation to prove that the goods or service matched what was described, a rebuttal addressing the cardholder\'s claims, and if applicable, ' +
        'documentation to prove that the cardholder did not attempt to return the merchandise.',
      explain51: 'The cardholder claims they are due a credit from an establishment that has not been processed.',
      explainAnswer51: 'In your response, you need to either show that the merchandise was never returned, that the cancellation was not accepted, or that a credit or a reversal was processed.',
      explain52: 'A transaction where authorization was required, but not obtained. It can also occur for transactions where the primary account number (PAN) does not exist.',
      explainAnswer52: 'Prove the transaction was presented within seven calendar days of the pre-authorization or authorization approval date and the pre-authorization or ' +
        'authorization was not reversed. You can also provide evidence that the issuer has not permanently closed the account or to prove that the transaction was either approved ' +
        'online by the issuer or offline by the chip.',
      explain53: 'The cardholder did not authorize or participate in a transaction conducted in a Card Not Present environment. ' +
        'OR A fraudulent transaction was completed in a Card Not Present environment using an account number for which no valid card was issued or is outstanding, ' +
        'and no authorization was obtained.',
      explainAnswer53: 'Respond to this dispute with Evidence of an imprint and a signature or PIN. ' +
        'If a non-authenticated security transaction was processed with an Electronic Commerce Indicator value 6 in the Authorization Request, ' +
        'provide proof that the issuer responded to the Authentication Request with a Cardholder Authentication Verification Value. Or, ' +
        'supply proof that the transaction was properly authorized.',
      explain54: 'A transaction where authorization was required, but not obtained. It can also occur for transactions where the primary account number (PAN) does not exist. ',
      explainAnswer54: 'Prove the transaction was presented within seven calendar days of the pre-authorization or authorization approval date and the pre-authorization or ' +
        'authorization was not reversed. You can also provide evidence that the issuer has not permanently closed the account or to prove that the transaction was either approved ' +
        'online by the issuer or offline by the chip.',
      explain55: 'The customer did not receive the merchandise or service.',
      explainAnswer55: 'Provide documentation to prove that the cardholder or an authorized person received the goods or services at the agreed location or by the agreed date.' +
        '\nIf the goods or services are in transit, provide tracking information and evidence that shows the delivery was carried out in a prompt manner.',
      explain56: 'The customer reports that the merchandise or service was not as described.',
      explainAnswer56: 'You need to provide documentation to prove that the goods or service matched what was described, a rebuttal addressing the cardholder\'s claims, ' +
        'and if applicable, documentation to prove that the cardholder did not attempt to return the merchandise.',
      explain57: 'The customer did not authorize the purchase of the merchandise or service. ' +
        'Liability has shifted to the Merchant due to collusion, fraud monitoring program thresholds, or any other reason.',
      explainAnswer57: 'Respond to this dispute with Evidence of an imprint and a signature or PIN. If a non-authenticated security transaction was processed with an ' +
        'Electronic Commerce Indicator value 6 in the Authorization Request, provide proof that the issuer responded to the Authentication Request with a Cardholder ' +
        'Authentication Verification Value. Or, supply proof that the transaction was properly authorized.',
      explain58: 'The purchase was canceled or returned, but the Refund has not been processed.',
      explainAnswer58: 'In your response, you need to either show that the merchandise was never returned, that the cancellation was not accepted, or that a credit or a reversal was processed.',
      explain59: 'Payment was processed twice',
      explainAnswer59: 'To respond, provide either two separate signed or imprinted transaction receipts or other record to prove that separate transactions were processed. ' +
        '\nOR respond by providing documentation to prove that you did not receive payment by other means for the same good or service.',
      explain60: 'The Payment amount differs from the agreed amount.',
      explainAnswer60: 'Provide the original transaction date and the trace number.',
      explain61: 'The customer paid for the transaction through other means.',
      explainAnswer61: 'Your response to this chargeback can include evidence that both transactions were valid and were authorized by PIN, a credit was issued, ' +
        'documentation indicating the two separate transactions and that they were valid, ' +
        'or that the chargeback is invalid because the issuer failed to provide the original ARD in DE 72 (Data Record).',
      explain62: 'Canceled services.',
      explainAnswer62: 'Provide proof that the disputed transaction was not cancelled, and that the cardholder did not give any demand to cancel said transaction.',
      explain63: 'The IBAN or BIC code provided by your customer is incorrect. ',
      explainAnswer63: 'Contact your customer to confirm the correct IBAN.',
      explain64: 'The account has been closed. The customer may have used an old account number or closed the account since setting up the mandate.',
      explainAnswer64: 'Contact your customer to get new account details.',
      explain65: 'The account has been blocked for Direct Debits either by the bank or your customer. It may be blocked by default, in which case the debtor can lift the block.',
      explainAnswer65: 'Contact your customer to ask for an alternative account/payment method.',
      explain66: 'A SEPA Direct Debit cannot be set up on this type of account. It is likely to be a savings account.',
      explainAnswer66: 'Contact your customer for information about the account to be used.',
      explain67: 'Invalid bank operation code.',
      explainAnswer67: 'Contact the payment gateway.',
      explain68: 'The payer\'s bank could not pay the Direct Debit due to insufficient funds.',
      explainAnswer68: 'Contact the customer to ensure they add funds to their account and resubmit the payment.',
      explain69: 'one of the following:\nThe cardholder paid twice for the same transaction using two different forms of payment.' +
        'The cardholder’s account has been debited more than once for the same transaction using the same form of payment',
      explainAnswer69: 'Your response to this chargeback can include evidence that both transactions were valid and were authorized by PIN, ' +
        'a credit was issued, documentation indicating the two separate transactions and that they were valid, ' +
        'or that the chargeback is invalid because the issuer failed to provide the original ARD in DE 72 (Data Record).',
      explain70: 'The customer name you have submitted does not match the actual account holder’s name of the account provided.',
      explainAnswer70: 'Contact your customer to check details.',
      explain71: 'Party who initiated the message is not recognised by the end customer.',
      explainAnswer71: 'Correct the Creditor Identifier and resubmit.',
      explain72: 'BIC code of the debtor’s bank unknown or does not match the IBAN.',
      explainAnswer72: 'This may occur if the IBAN corresponds to an account in Switzerland but the debtor’s address has not been transmitted.',
      explain73: 'Invalid file format.',
      explainAnswer73: 'Contact your payment gateway.',
      explain74: 'local instrument code.',
      explainAnswer74: 'Contact your payment gateway.',
      explain75: 'The cardholder states that neither he, she, nor anyone authorized by him or her engaged in the transaction.',
      explainAnswer75: 'Provide an explanation and copies of written correspondence exchanged between you and the cardholder (such as a letter, email, or fax) showing that the cardholder, ' +
        'or an authorized user, participated in the transaction.',
      explain76: 'Mandate data missing or incorrect',
      explainAnswer76: 'Contact your payment gateway.',
      explain77: 'Your customer has claimed a refund for an authorised transaction.',
      explainAnswer77: 'Contact your customer.',
      explain78: 'You have attempted to set up a mandate on the account of someone who is deceased. Extremely rare.',
      explainAnswer78: 'End the agreement with the deceased customer.',
      explain79: 'The debtor refuses this particular collection. ',
      explainAnswer79: 'Contact your customer.',
      explain80: 'One of the most common error codes. Often used when banks choose not to issue more specific reason codes for data protection reasons.',
      explainAnswer80: 'Contact your customer.',
      explain81: 'The BIC code provided by your customer is incorrect. ',
      explainAnswer81: 'Contact your customer for the correct BIC.',
      explain82: 'The payer’s account information is missing.',
      explainAnswer82: 'Contact your payment gateway.',
      explain83: 'The payer’s name or address details are missing. ',
      explainAnswer83: 'Contact your payment gateway.',
      explain84: 'Your name or address details are missing. You can perform these checks yourself before submitting.',
      explainAnswer84: 'If it due to missing information amend the collection and resubmit. If it is a regulatory reason contact the customer\'s bank.',
      explain85: 'Regulatory reason.',
      explainAnswer85: 'You should contact your Bank and request that they contact the Payer\'s Bank to find out the rejection reason.',
      explain86: 'The request clashes with specific instructions that the buyer has configured for his or her account.\nE.g.: the creditor is blacklisted.',
      explainAnswer86: 'Contact your customer.',
      explain87: 'Cut off time.',
      explainAnswer87: 'The time limit has passed.',

      disputeInfo: 'Dispute information',
      disputeReason: 'Dispute reason',
      disputeDetail: 'Dispute details',
      titleTip: 'This page lists transactions that are at risk of chargeback. <br>You can review and complete the refund process by yourself.',
    },
    subscription: {
      contractNo: 'Contract number',
      contractId: 'Contract id',
      collectionMethod: 'Collection method',
      createDate: 'Start date',
      expireDate: 'Expire Date',
      frequency: 'Collection frequency',
      baseInfo: 'Subscription basic information',
      productInfo: 'Subscribe product information',
      status: 'Status',
      billingCycle: 'Billing cycle',
      cardInfo: 'Card information',
      cardNo: 'Card number',
      defaultCardNo: 'Default payment card',
      customerInfo: 'Customer information',
      customerName: 'Customer name',
      txnHistory: 'History subscription transaction record',
      details: 'Subscription details',
      cancelConfirm: 'Confirm to cancel this subscription',
      statusData: {
        0: 'Initiated',
        1: 'Active',
        2: 'Close',
        3: 'Cancelled',
      },
      paymentMethodData: {
        1: 'Auto initiated',
        2: 'Merchant initiated',
      },
      frequencyData: {
        Y: '{year} years',
        Mon: '{mon} months',
        W: '{week} weeks',
        D: '{day} days',
        H: '{hour} hours',
        M: '{minute} minutes',
      },
      _frequencyData: {
        Y: 'per {value} year | {value} years',
        M: 'per {value} month | {value} months',
        W: 'per {value} week | {value} weeks',
        D: 'per {value} day | {value} days',
        H: 'per {value} hour | {value} hours',
      },
      frequencyFormatter: {
        Y: 'per {value} year | per {value} years',
        M: 'per {value} month | per {value} months',
        W: 'per {value} week | per {value} weeks',
        D: 'per {value} day | per {value} days',
        H: 'per {value} hour | per {value} hours',
      },
      remindEmailTitle: 'Subscription reminder email',
      remindEmailDesc: 'Once enabled, users will receive emails about subscription creation, renewals, payments (successful/failed), cancellations, and changes.',
      changeInfoText: 'After the change, the billing date will be set to the date of the change, starting from cycle 1. Future charges will follow the new subscription plan.',
      quickAccess: 'Quick Access',
      keyInfo: 'Key Information',
      subscriptionInfo: 'Subscription details',
      customerInformation: 'Customer details',
      deductionHistory: 'Collection history',
      assessedAmount: '分摊金额',
      billingCountsTips: '<div>Display the current billed cycle counts and total number of cycle counts:</div><div>A dash ("--") indicates ongoing billing with no end cycle count.</div><div>A value between 1 and 100 indicates a set number of billing cycle counts.</div>',
      collectionTime: 'Billing time',
      hasSubscription: '\'s Subscription to',
      cancelSubsBtn: 'Cancel',
      subsInfo: 'Subscription details',
      editBtn: 'Edit',
      nextCollectionTime: 'Next billing',
      nextCollectionAmount: 'Billing amount',
      timeliness: 'Service Validity Period',
      contractUpdateTime: 'Update initiation date',
      transactionUrl: 'Transaction url',
      trailEndDate: 'Trial ends on',
      productName: 'Product name',
      startDate: 'Start date',
      endDate: 'End date',
      billingCounts: 'Billing counts',
      billingFrequency: 'Billing frequency',
      productPrice: 'Price',
      productQuantity: 'Quantity',
      productCount: 'Quantity',
      billingAmount: 'Billing amount',
      customerId: 'Customer ID',
      paymentMethods: 'Payment method',
      editSubsInfo: 'Edit subscription details',
      cancelSubsDialogTitle: 'Cancel subscription',
      exportBtn: 'Export',
      email: 'Customer Email',
      cancelSubsBtn1: 'Cancel after current cycle',
      cancelSubsBtn2: 'Cancel on specified date',
      // 立即取消
      cancelSubsBtn3: 'Cancel immediately',
      _cycleCount: 'Billing counts',
      cycleCount: 'Total Billing counts',
      orderAmount: 'Billing amount',
      proration: 'Proration amount',
      pickDateTip: 'Please select a specific date',
      hugeMoneyTip: 'Excessive amount',
      expireDateErrorTips: 'Please provide the correct expiration date based on billing frequency and cycle.',
      prorationTip: 'When upgrading or downgrading a subscription, the proration amount represents the amount you wish to charge or refund the customer immediately:',
      prorationTip1: '0: No charge/refund to the customer',
      prorationTip2: 'Positive amount: Charge the customer the corresponding amount',
      prorationTip3: 'Negative amount: Refund the customer the corresponding amount (currently not supported)',
      statusActiveTip: 'Subscription change request confirmed. View details in subscription information.',
      statusCancelTip:
        'The subscription will be cancelled on the specified date.',
      statusUpdatingTip:
        'The subscription will be updated on the specified date.',
    },
    wallet: {
      time: 'Time',
      subAccountType: 'Sub-account type',
      openingAmount: 'Opening amount',
      closingAmount: 'Ending amount',
      movingAmount: 'Amount of change',
      recharge: 'Add funds',
      payout: 'New transfer',
      rechargeTitle: 'Add funds to your {currency} account',
      rechargeSubTitle: 'Please follow the information below to fund your {currency} wallet by making a transfer.',
      rechargeCurrencyInfo: '{currency} Funding Information',
      rechargeWaring: 'Please make sure to use the exact account name below, otherwise your funds may be refunded.',
      rechargeForAccount: 'Fund your account',
      selectRechargeCurrency: 'Please select the currency to fund your account',
      rechargeBankInfo: 'Bank account information:',
      // eslint-disable-next-line max-len
      rechargeTips1: '1. Complete the offline payment to complete the top-up of the current account currency. Your funds will be processed in 1~2 working days and will be added to your account balance.',
      rechargeTips2: '2、Please note that when making a bank payment, please make sure to fill in the correct "Transaction Attachment".',
      openRechargeVa: 'Create a top-up account',
      actAmountTips: 'Total amount = Available balance + Amount to be settled + Frozen amount + Margin amount',
      // TODO
      rechargeTips: '{currency}充值，请与您的客户经理联系',
      externalOrder: 'A Transaction Return Fee has been charged. Associated Payment serial number: {externalOrderID}',
      refundTitle: 'Transaction Return Fee',
    },
    download: {
      modalTitle: 'Current download content',
      fileName: 'File Name',
      source: 'Source Function',
      gotoDownloadCenter: 'Open the Download Center',
      downloadCenter: 'Download Center',
      gotoUploadDetails: 'Open the upload details page',
      taskManager: 'Task management',
    },
    notice: {
      message: 'Message',
      noticeCenter: 'Message Center',
      noticeDetail: 'Message details',
      notice: 'Announcement',
    },
    searchCommon: {
      all: 'All',
      search: 'Search',
      startTime: 'Start time',
      endTime: 'End time',
      startTimeTip: 'Please select {time}->start time',
      endTimeTip: 'Please select {time}->end time',
      stowOptions: 'Stow Options',
      moreOptions: 'Filter',
    },
    tableTitleCommon: {
      saveConfiguration: 'Save configuration',
      defaultConfiguration: 'Use default configuration',
      visibleColumns: 'Visible Columns',
      selectOneTitle: 'Select at least three titles',
      previous: 'Previous',
      next: 'Next',
    },
    tableCommon: {
      operator: 'Operator',
      operation: 'Operation',
      operationTime: 'Operation time',
      LatestOperationTime: 'Last operation time',
      appeal: 'Rebut',
      see: 'View',
      acceptDishonor: 'Accept chargeback',
      website: 'Transaction URL',
      cardType: 'Payment method',
      subCardType: 'Sub payment method',
      remark: 'Remark',
      txnSerialNumber: 'Transaction ID',
      merchantOrderNumber: 'Merchant order ID',
      merchantOriginalOrderNumber: 'Original transaction ID',
      // 卡类型
      cardCategoryName: 'Card category',
      // 卡标识
      cardIdentifier: 'Card product',
      originalTxnSerialNumber: 'Original transaction ID',
      originalTxnSerialNumber_new: 'Transaction ID',
      subProductType: 'Payment mode',
      productType: 'Product type',
      bankCardNo: 'Card number',
      cardNumber: 'Card Number',
      appId: 'App ID',
      appName: 'App name',
      appType: 'App type',
      appWebsite: 'App website',
      arn: 'ARN',
      email: 'Email',
      refundState: 'Refund state',
      cardBinCountry: 'Issuing country',
      products: 'Products information',
      userAgent: 'User agent',
      auditStatus: 'Approval status',
      onlineRefundStatus: 'Refund status',
      refundType: 'Refund type',
      refundTime: 'Refund application time',
      refundDate: 'Refund time',
      refundAuditTime: 'Refund audit time',
      refundCompletedTime: 'Refunded time', // 新增退款完成时间翻译 - Added Refunded time translation
      originTxnAmount: 'Origin transaction amount',
      originTxnTime: 'Origin transaction time',
      txnTime: 'Transaction time',
      txnType: 'Transaction type',
      txnStatus: 'Transaction status',
      orderAmount: 'Transaction amount',
      txnAmount: 'Transaction amount',
      refund: 'Refund',
      refundAmount: 'Refund amount',
      refundedAmount: 'Refunded amount',
      refundSucceedAmount: 'Refunded amount',
      refundReviewNumber: 'Refund review serial number',
      eci: 'ECI Result',
      requestId: 'Unique request number',
      ip: 'IP',
      require3d: 'Request 3DS',
      currency: 'Currency',
      // 订单币种
      transaction_currency: 'Transaction currency',
      serialNumber: 'ID',
      refundsRevoke: 'Revoked',
      updateTime: 'Update time',
      details: 'Details',
      status: 'Ledger status',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      notFoundInfo: 'No information found',
      searcnEmpty: 'The query has no information',
      schemeAmt: 'Scheme fee',
      markupAmt: 'Acquiring fee',
      interchangeAmt: 'Interchange fee',
      taxes: 'Taxes',
      default: 'Default',
      makeDefault: 'Make Default',
      platformFee: 'Platform fee',
      platformType: 'Platform type',
      bankAddress: 'Bank address',
      bankName: 'Bank name',
      creationTime: 'Creation time',
      refundSerialNumber: 'Refund ID',
      accountNotOpened: 'No account',
      otherReason: 'Other discription',
      supplementary: 'Supplementary description',
      auditOpinion: 'Review opinion',
      auditTime: 'Review time',
      audit: 'Review',
      firstName: 'First Name',
      lastName: 'Last Name',
      isCompleted: 'Completed or not',
      selectDate: 'Select date',
      downloadResultFile: 'Download the results file',
      successfulAmountDay: 'Today\'s total successful amount',
      // 当日成功订单金额
      daily_successful_transaction_amount: 'Daily successful transaction amount',
      // 当日结算币种金额
      daily_settlement_currency_amount: ' Daily settlement currency amount',
      successfulCountDay: 'Total number of successful transactions today',
      successfulRateDay: 'Today\'s transaction success rate',
      createDate: 'Creation date',
      successfulCount: 'Total number of successful transactions',
      successfulAmount: 'Total successful amount',
      refuseCount: 'Total number of chargebacks',
      refuseAmount: 'Chargebacks total amount',
      refuseRate: 'Chargebacks rate',
      explanation: 'Explain',
      card: 'Card payment',
      lpms: 'Local payment',
      queryHistory: 'Whether to query history',
      lastUpdatedTime: 'Updated Date',
      atSelectLeastOne: 'Select at least one',
      paymentType: 'Payment method',
      amount: 'Amount',
      fraudAdministrationFee: 'Fraud administration fee',
      disputePresence: 'Chargeback Status',
      notificationOfFraud: 'Notification of Fraud',
    },
    report: {
      refuseRateDetails: 'Details',
      transactionReportDetails: 'Details',
      successCurrencyTooltip: 'All: Orders in different currencies are converted to USD in real time for overall success rate display. Reference only, not for settlement or reconciliation.',
      refuseCurrencyTooltip: 'All: Orders in different currencies are converted to USD in real time for overall success rate display. Reference only, not for settlement or reconciliation.',
    },
    status: {
      yes: 'Yes',
      no: 'No',
      activation: 'Active',
      inactivated: 'Not active',
      noRefund: 'Not refunded',
      allRefund: 'Full refund',
      partRefund: 'Partial refund',
      unaudited: 'To be reviewed',
      auditSuccess: 'Approved',
      auditFail: 'Declined',
      auditSuccessAndRefund: 'Pass and refund',
      onlineRefunds: 'Refund in progress',
      onlineRefundsRequest: 'Refund requested',
      onlineRefundsSuccess: 'Refund succeeded',
      onlineRefundsFail: 'Refund failed',
      onlineRefundsCancel: 'Refund canceled',
      onlineRefundsPassed: 'Refund approved',
      onlineRefundsRejected: 'Refund rejected',
      cannotOnlineRefunds: 'Cannot refund online',
      cancel: 'Cancel',
      inForce: 'Actived',
      notForce: 'Not active',
      refuse: 'Chargeback',
      acceptedSuccess: 'Accepted successfully',
      noReviewRequired: 'No check',
      parsingPending: 'To be parsed',
      parsing: 'Parsing',
      parsingSucceeded: 'Parsing succeeded',
      parsingFail: 'Parsing error',
      parseingCancel: 'Cancel parsing',
      succeed: 'Succeed',
      succeedPartial: 'Partial success',
      fail: 'Fail',
      processing: 'Processing',
      pending: 'Pending',
      undone: 'Incomplete',
      done: 'Completed',
      existAuditSuccess: 'Existence of audited',
      existUnAudit: 'Existence of unaudited',
      uploaded: 'Yes',
      notUploaded: 'No',
      paid: 'Paid',
      unpaid: 'Unpaid',
      retry: 'retry',
      // 保存成功
      saveSuccess: 'Save successfully',
    },
    collection: {
      transactionRejectedTipTitle: 'Your B2B Collection transaction is rejected',
      transactionPendingTipTitle: 'Your B2B Collection transaction is Under review',
      transactionPendingTipReason: 'Your B2B Collection transaction is under review, You can submit the review materials, you can contact our customer service for process',
      type: 'Type',
      accountNumber: 'Account number',
      accountType: 'Account type',
      payerAccountName: 'Payer account name',
      payerAccountNumber: 'Payer account number',
      settlementTime: 'Settlement time',
      virtualAccountNumber: 'Virtual account number',
      virtualAccountName: 'Virtual account name',
      virtualAccount: 'Virtual Account',
      createVirtualAccount: 'Create virtual account',
      editVirtualAccount: 'Edit virtual account',
      createVirtualAccount1: 'Create global account',
      editVirtualAccount1: 'Edit global account',
      emptyTopTitle: 'Enter new overseas markets with ONERWAY',
      emptyTopDesc01: 'Open a global fund collection account, with supporting international currencies as USD, EUR, GBP, JPY and many other.',
      emptyTopDesc02: 'Explore new markets and grow your cross-border business with ONERWAY.',
      emptyContentTitle01: 'Easy account opening',
      emptyContentDesc01: 'Open an account within 2 hours on ONERWAY website.',
      emptyContentTitle02: 'Rapid withdrawal',
      emptyContentDesc02: 'We help merchants to collect money from marketplaces and withdraw cash as fast as T+0.',
      emptyContentTitle03: 'Best rate',
      emptyContentDesc03: 'Benefit from real-time transparent exchange rate without any loss.',
      emptyContentTitle04: 'No FX limits',
      emptyContentDesc04: 'No personal exchange limit.',
      vaFormTitleTips: 'Please fill in your virtual account information',
      createVaSuccessTips: 'Virtual account created successfully',
      selectCountry: 'Country of bank account',
      accountFunction: 'Account function',
      accountInfo: 'Account info',
      accountHolderName: 'Account holder name',
      companyAddress: 'Company Address',
      accountCurrency: 'Account currency',
      bizType: 'Business type',
      bankLocation: 'Bank location',
      bankCountry: 'Bank country',
      accountLabel: 'Account label',
      note: 'note',
      iban: 'IBAN',
      swift: 'SWIFT',
      vaAccountDetails: 'Account details',
      vaTransDetails: 'Account transaction details',
      acType: 'Account type',
      name: 'Name of shareholders (more than 25% of shares)',
      address: 'Address',
      street: 'Street',
      city: 'City',
      country: 'Country',
      entityType: 'Entity type',
      errorTitle: 'The current audit did not pass, please modify the application information',
      bankName: 'Bank account name',
    },
    upload: {
      tip: 'You can drag more files here to upload<br> - OR -',
      limitTip: 'You uploaded too many files',
      zipOrImgtip: 'Support zip,jpeg,jpg,png,pdf format <br>-maximum size of 50M-',
      supportFileTip: 'Support {type} format <br>-maximum size of 50M-',
      supportFileAndSizeTip: 'Support {type} format, -maximum size of {size}-',
    },
    transfer: {
      availableLimit: 'Available limit',
      uploadDate: 'Upload date',
      uploadNumber: 'Upload serial number',
      quota: 'Quota',
      transferId: 'Payment serial number',
      merchantReference: 'Merchant Reference',
      beneficiary: 'Payee',
      sendAmount: 'Payment amount',
      receivedAmount: 'Payment amount',
      completionTime: 'Payment time',
      receiptDownload: 'Export',
      transferMoney: 'To pay',
      transferMoneyAcq: 'Withdraw',
      addTransferMoneyDescription: 'With just a few clicks, you can transfer money online from our website, whether through local transfer or swift transfer.',
      addTransferMoneyDescriptionAcq: 'According to the contract agreement, the funds from your acquiring business will be automatically transferred to the designated withdrawal account on a regular basis.',
      transferCurrency: 'Deduction currency',
      transferAmount: 'Deduction amount',
      transferFee: 'Service charge',
      currencyReceived: 'Payment currency',
      amountReceived: 'Estimated Payout',
      amountReceived1: 'Estimated Payout',
      payoutPostscri: 'Payment Reference',
      referenceTips: 'The Payout remark may not be displayed to the beneficiary due to the payee bank, or it may be truncated for length reasons.',
      payPurpose: 'Payment purpose',
      payDoc: 'Payment certificate',
      contactNickname: 'Payee',
      recipient: 'Payee',
      contactName: 'Payee',
      youSend: 'You send',
      beneficiaryGets: 'Expected receipt by payee',
      transactionPurpose: 'Transaction purpose',
      certificate: 'File',
      payeeInformation: 'Payee information',
      payoutFee: 'Fee',
      recipientGets: 'Expected receipt by payee',
      contact: 'Payee',
      cardHolder: 'Cardholder',
      swiftCode: 'Swift code',
      email: 'Verification code',
      verfiyCode: 'Get verification code',
      who: 'Who do you want to pay?',
      youContacts: 'Your payee',
      newContacts: 'Create new payee',
      addContact: 'Add a payee',
      transactionNumber: 'Serial number',
      payTime: 'Payment time',
      payStatus: 'Payment status',
      serviceFee: 'Fee',
      otherFee: 'Other amount',
      auditRemark: 'Payment description',
      verfiyCodeTip: 'The verification code has been sent to your email, please check',
      payer: 'Payer',
      insufficientBalance: 'Insufficient balance available',
      moreThanFee: 'Payment amount must be greater than the handling fee amount',
      transferToAct: 'Payment to  {payee}',
      details: 'Payment details',
      amount: 'Amount',
      frozenAmount: 'Frozen amount',
      rate: 'Rate',
      payoutInfo: 'Payment information',
      uploadRestoreDetails: 'Restore detailed declaration',
      limitMinAmount: 'The transaction amount is less than the minimum amount allowed with a minimum amount of 10.00',
      batchTransferMoney: 'Batch Payments',
      batchTransferModalTitle: 'Upload a batch payment file',
      batchTransferResultTitle: 'Summary of this batch payment file',
      downloadReport: 'Download Statement',
      downloadCurReport: 'Download current statement',
      batchFileError: 'There is an error in the batch payment file, please download the report to view the details',
      batchTransferCount: 'Total number of payments',
      b1atchTransferTotalAmount: 'Total Payment Amount',
      missingError: 'Current {currency} account available balance is {availBalance}, total pre-deduction amount {preDeductionAmount}, missing {shortageAmount}',
      batchTransferError: 'Can’t complete the payment, please recharge or modify the batch payment file and try again',
      batchTransferTemplate: 'Batch payment template',
      needCode: 'The verification code is incorrect, please re-fetch and try again.',
      fileBatchNo: 'Document Batch Number',
      payoutVoucherBatch: 'Batch Download Payment Voucher',
      payoutVoucher: 'Payment Voucher Download',
      transferAmountTips: 'The settlement time may vary depending on the payment currency and amount.',
      ownContacts: 'Myself',
      otherContacts: 'Someone else',
      designatedPayer: 'Specify the payer',
      willEchangeAmount: 'Amount to be converted',
      validWithin: 'Valid in <span style="color:#0094C6;">{time}</span>',
      saveContactInfo: 'Save/Update Account Information',
      payoutPurpose: 'Purpose of Payment ',
      paymentMethod: 'Payment Method',
      fundsSource: 'Source of Funds',
      howToPayoutMethod: 'How would you like the recipient to receive the payment?',
      bankTransfer: 'Bank transfer',
      eWallet: 'Wallet transfer',
      cashPickup: 'Cash withdrawal',
      noTransferMethodTips: 'The payment area or method is temporarily unavailable. Please try again after changing.',
      currencyAmountTips: '{currency} only whole numbers are allowed, please delete decimal places.',
      noTransferFieldsTips: 'Current payment is not supported, please contact us.',
      validationInpro: 'Validation in progress',
      validatedCount: 'A total of',
      validatedNum: 'payment transactions are being validated',
      validatedS: 'success ',
      validatedF: 'failed',
      confirmWord: 'A document is being validated, confirm cancellation or not.',
      taskErr: 'There is an error in your uploaded file, please contact your account manager for support。',
      feeBearing: 'Cover the intermediary and correspondent bank fees for recipient to get full amount.',
      feeBearingTips: 'Exceptions may apply if the intermediary, correspondent or the recipient bank does not adhere to the SWIFT instruction and lifts a fee from the amount recipient gets after a transfer is sent.',
      feeWarning: 'less any intermediary and correspondent bank fees.',
      feeBearingTitle: 'Fee Type',
      failReason: 'Failure Reason',
      successTitle: 'Your transfer has been created successfully',
      paymentSerialNumber: 'Payment serial number',
      newTransfer: 'New transfer',
      backToTransfers: 'Back to transfers',
      // 批量审核相关翻译 / Batch approval related translations
      batchApproval: 'Batch Pass',
      batchReject: 'Batch Reject',
      selectedCount: 'Selected {count} items',
      selectItemFirst: 'Please select items to operate first',
      approvalConfirmTitle: 'Batch Approval Confirmation',
      approvalConfirmContent: 'Are you sure you want to batch approve the selected {count} items?',
      rejectConfirmTitle: 'Batch Rejection Confirmation',
      rejectConfirmContent: 'Are you sure you want to batch reject the selected {count} items?',
      rejectReason: 'Rejection Reason',
      pleaseEnterRejectReason: 'Please enter rejection reason',
      rejectReasonRequired: 'Rejection reason cannot be empty',
      rejectReasonLength: 'Rejection reason length should be between 1-200 characters',
      batchApprovalSuccess: 'Batch approval successful',
      batchRejectSuccess: 'Batch rejection successful',
      partialSuccess: 'Partial operation successful, {count} items succeeded',
      noRecordsToProcess: 'No records meet the criteria for processing',
      operationCompleted: 'Operation completed',
      approval: 'Approval',
      reject: 'Reject',
      singleApprovalConfirmTitle: 'Confirm Approval',
      singleApprovalConfirmContent: 'Are you sure you want to approve this payment?',
      approvalSuccess: 'Approval successful',
      singleRejectReason: 'Rejection Reason',
      singleRejectReasonPlaceholder: 'Please enter rejection reason (optional)',
      confirmReject: 'Confirm Reject',
      rejectSuccess: 'Rejection successful',
      operationFailed: 'Operation failed, please retry',
      feeChargeModetipsfalse: 'This amount fluctuates with the exchange rate, because the amount recipient gets was specified',
      feeChargeModeTipstrue: 'This amount fluctuates with the exchange rate, because the amount you pay was specified',
      beingProcessed: 'Being processed',
      failed: 'Failed',
      failedTips: 'Your transfer has not been created',
      transLoading: 'Calculating the total transaction amount',
      walletFormat: 'Wallet format',
    },
    payoutInfo: {
      payoutInfo: 'payer information',
      companyName: 'Company English Name',
      country: 'Country of Registration',
      addressEn: 'Registered Address',
      registrationNumber: 'Registration Number',
      registrationDate: 'Registration Date',
      postalCode: 'Postal Code',
      payerName: 'Payer Name',
    },
    exchange: {
      sameCurrency: 'The sell currency and the buy currency cannot be the same',
      exchangeMoney: 'Exchange',
      addExchangeMoneyDescription: 'You can use the available balance in the wallet to exchange, and the exchanged currency will be stored in the corresponding currency wallet.',
      exchangeId: 'Exchange serial number',
      currencyExchange: 'Currency pair',
      rate: 'Exchange rate',
      sell: 'Sell',
      originCurrency: 'Source Currency',
      targetCurrency: 'Target currency',
      buy: 'Buy',
      deliveryDate: 'Delivery date',
      continue: 'Continue',
      amount: 'Amount',
      review: 'Confirm',
      youSell: 'Sell',
      youBuy: 'Buy',
      referenceRate: 'Reference exchange rate',
      payoutInfo: 'Confirmation of exchange information',
      guaranteedRate: 'Exchange rate',
      refresh: 'Refresh',
      holidayTip: 'Current time/currency does not support trading, ',
      seeDetails: 'see details',
      exchangeTips1: 'T0 trading hours, USD、HKD mutual exchange is until 16:00, SGD related exchange is 11:00, other currencies exchange is until 15:00',
    },
    risk: {
      blacklist: 'Blacklists',
      addBlacklist: 'New Blacklist',
      addBlacklistdialog: {
        addTitle: 'Create Blacklist',
        editTitle: 'Edit Blacklist',
        blacklistName: 'Blacklist Name',
        attribute: 'Attribute',
        type: 'Type',
        dataCount: 'Items',
        allDesc: 'All payment transacitons will be affected.',
        cardDesc: 'Only card payment transactions will be affected.',
        lpmsDesc: 'Only local payment transactions will be affected.',
        applyTo: 'Apply To',
        applyToTips: 'Please select the payment type to which this blacklist would be applied.',
        blacklistType: 'Blacklist Type',
        // You need to complete the following steps:
        // 1. Download the template;
        // 2. Fill in according to the example;
        // 3. Click or drag and drop to upload the file
        batchRiskTemplateTips: [
          'You need to complete the following steps: ',
          '1. Download the template; ',
          '2. Fill in according to the example; ',
          '3. Click or drag and drop to upload the file.',
        ],
      },
      editBlacklist: 'Edit Blacklist',
      addBlacklistTips: [
        ' Block high-risk transactions by filtering specific data points such as email addresses,IP addresses,card numbers and phone numbers.',
        'When properly configured, blacklists can effectively reduce fraud rates by up to 50%.',
      ],
      name: 'Name',
      attribute: 'Attribute',
      type: 'Type',
      dataCount: 'Items',
      creator: 'Created by',
      // addBy
      addBy: 'Add By',
      lastModifiedDate: 'Last Modified',
      value: 'Value',
      createDate: 'Date Added',
      listAttribute: 'List Properties',
      listType: 'List Type',
      listName: 'List Name',
      hitCount30Day: 'Hit Count',
      // Hit Rate(30day)
      hitRate30Day: 'Hit Rate',
      // Hit Rate (30day)
      hitRate30Days: 'Hit Rate (30days)',
      confirmTip: 'Does {operate} this rule?',
      single: 'Single',
      multi: 'Multiple',
      uploadTip: 'Uploads a list of items in xlsx file format. Maximum file size is 5M',
      // 电话号码
      phone: 'Phone Number',
      ip: 'IP Address',
      email: 'Email (Shipping & Billing)',
      emailDomain: 'Email Domain',
      batchRiskTemplate: 'Batch_list_import',
      effectiveDate: 'Expiration date',
      batchFileError: 'There is an error in the list import file, please download the report to check the details.',
      scope: 'Scope of validity',
      active: 'Active',
      disabled: 'Inactive',
      // 卡号明文
      cardPlaintext: 'Card number plaintext',
      // 请输入卡号
      cardInputPlaceholder: 'Please enter the card number',
      transactionIdPlaceholder: 'Please enter the transaction serial number',
      all: 'All payments',
      card: 'Card Payments',
      lpms: 'Local payments',
      // 手工输入
      manualInput: 'Manual Input',
      // 上传CVS
      uploadCsv: 'Upload CSV',
      // 过期日期
      expireDate: 'Expire Date',
      // 过期日期提示文案
      expireDateTips: 'If expire date is not set, the items added will be long-term valid.',
      // 通过交易流水号检索
      searchByTransactionId: 'By Transaction ID',
      status: {
        // 全部状态
        allStatus: 'All Status',
        // 激活
        active: 'Active',
        // 未激活
        inactive: 'Inactive',
        // 即将过期
        expiringSoon: 'Expiring Soon',
      },
      // 条目数据
      itemsData: 'Items',
      // 添加条目数据页面
      itemsDataTips: 'Add Items to Blacklist',
      addBlackListItem: {
        addItemsToBlacklist: 'Add Items to Blacklist',
        addItems: 'Add Items',
        itemsDataPlaceholder: {
          enterDataOnePerLine: 'Enter data (one per line)',
          example: 'Example:',
          example2: '@spam.com',
          example3: '@blacklist.com',
        },
        // If the Expire Date is not set, the value is valid for a long time.
        expireDateTips: 'If expire date is not set, the items added will be long-term valid.',
      },
      searchItems: 'Search Items ...',
      // 当前条目数据汇总
      currentItemsSummary: 'Current Items Summary',
      // 启用所选(Activate Selected)
      activateSelected: 'Enable Selected',
      // 禁用所选(Deactivate Selected)
      deactivateSelected: 'Disable Selected',
      // 更新数据(Update Expire Date)
      updateExpireDate: 'Update Expire Date',
      // 导出(Export)
      export: 'Export',
      // 请选择条目数据(Please select items data)
      pleaseSelectItems: 'Please select items data',
      // Deactivate
      deactivate: 'Deactivate',
      // Activate
      activate: 'Activate',
      // Set Expire Date
      setExpireDate: 'Set Expire Date',
      // last hit time
      lastHitTime: 'Last Hit',
      confirmTips: 'Sure to {operate} the items?',
      // Total
      total: 'Total',
      copy: 'Copy',
      // 无过期
      noExpiration: 'No Expiration',
      exampleFile: {
        title: 'Example rules',
        subtitle: 'CSV File Guidelines',
        format: 'Use',
        csv: '.csv',
        withColumns: 'format file with the following columns:',
        columns: 'columns',
        columnNames: 'value,type,status,expire date,remarks',
        valueCanBe: 'Item value can be ',
        // originaldata
        originalData: 'original data',
        or: ' or ',
        transactionOrEmail: 'transaction IDs',
        // addresses/suffixes
        transactionOrEmailDesc: 'system will query associated original data',
        typeShouldBe: 'Type should be',
        typeC: '"C" - Original value',
        typeCDesc: '(email address/suffix)',
        typeM: '"M" - Transaction ID',
        typeMDesc: '(system will query associated original data)',
        statusShouldBe: 'Status should be',
        active: '"Active"',
        inactive: '"Inactive"',
        expiryDate: 'Expiry date is optional, format:',
        dateFormat: 'YYYY-MM-DD',
        allValues: 'All values must be in ',
        plainText: 'plain text',
        noMasking: ' (no masking) ',
      },
    },
    alert: {
      info: 'Alert Info',
      caseInfo: 'Case Info',
      ethocaId: 'Ethoca ID',
      rdrId: 'Case ID',
      merchantOrderId: 'Merchant order ID',
      alertType: 'Alert Type',
      caseType: 'Case Type',
      resellerSubMerchantId: 'Reseller Sub Merchant ID',
      resellerSubMerchantIdInputTips: 'For Identifying Merchants',
      billDesc: 'Billing Descriptor',
      billingDescriptorInputTips: 'Merchant Name/URL/Address',
      alertTime: 'Alert Time',
      enrollmentTime: 'Enrollment Date',
      updateTime: 'Updated Date',
      lastUpdatedDate: 'Updated Date',
      updatedUser: 'Updated User',
      authTime: 'TXN Date',
      outcome: 'Outcome',
      outcomeStatus: 'Status',
      refundStatus: 'Refund Status',
      enrollmentStatus: 'Status',
      alertAge: 'Alert Age (hour)',
      initiatedBy: 'Initiated By',
      liability: 'Liability',
      merchantIdentifier: 'Merchant Identifier',
      ethocaMerchantId: 'Ethoca Merchant ID',
      integratorMemberId: 'Integrator Member ID',
      transactionInfo: 'Transaction Info',
      amount: 'Amount',
      currency: 'Currency',
      merchant: 'Merchant',
      descriptor: 'Descriptor',
      arn: 'ARN',
      BIN: 'BIN',
      CAID: 'CAID',
      DBA: 'DBA',
      MCC: 'MCC',
      BINInputTips: 'Acquirer ID',
      CAIDInputTips: 'Card Acceptor ID',
      DBAInputTips: 'Merchant Name/URL',
      MCCInputTips: 'Summited MCC',
      preDisputeServiceInputTips: 'Pre-dispute service',
      BINInputTips2: 'Acquirer ID',
      MCCInputTips2: 'Submitted MCC may differ from alerted transactions',
      resellerSubMerchantIdInputTips2: 'For identifying merchants',
      ARNInputTips: 'Mandatory when transactions exits',
      outcomeUpdatedTime: 'Outcome Updated Time',
      caseReceivedDate: 'Case Received Date',
      pricingTier: 'Pricing Tier',
      updateDate: 'Updated Date',
      submitEnrollment: 'Submit Enrollment',
      withdrawEnrollment: 'Withdraw Enrollment',
      submitDisenrollment: 'Submit Disenrollment',
      withdrawDisenrollment: 'Withdraw Disenrollment',
      issuer: 'Issuer',
      cardNumber: 'Card Number',
      transactionType: 'Transaction Type',
      authCode: 'Auth Code',
      transactionId: 'Transaction ID',
      chargebackInfo: 'Chargeback Info',
      chargebackReasonCode: 'Chargeback Reason Code',
      chargebackAmount: 'Chargeback Amount',
      chargebackCurrency: 'Chargeback Currency',
      outcomeInfo: 'Outcome Info',
      caseAmount: 'Case Amount',
      caseCurrency: 'Case Currency',
      reasonCode: 'Reason Code',
      caseSource: 'Case Source',
      caseStatus: 'Status',
      caseStatusCode: 'Status Code',
      caseRuleType: 'Rule Type',
      caseRuleName: 'Rule Name',
      rdrPartnerName: 'RDR Partner Name',
      rdrPartnerID: 'RDR Partner ID',
      rdrClientName: 'RDR Client Name',
      rdrClientID: 'RDR Client ID',
      rdrMerchantName: 'RDR Merchant Name',
      rdrMerchantID: 'RDR Merchant ID',
      rdrContact: 'DBA (Contact)',
      authDate: 'TXN Date',
      caseAuthorizationCode: 'Case Authorization Code',
      cardBin: 'Card BIN',
      cardLastFour: 'Card Last Four',
      paymentType: 'Payment Type',
      ethocaAlertDetails: 'Ethoca Alert Details',
      ethocaEnrollmentDetails: 'Ethoca Enrollment Details',
      rdrAlertDetails: 'RDR Case Details',
      rdrEnrollmentDetails: 'RDR Enrollment Details',
      alertDate: 'Alert Date',
      cardHash: 'SHA1 Hashed Card Number',
      merchantMid: 'Merchant Descriptor/MID',
      source: 'Source',
      refundedOrNotSettled: 'Refunded/Not Settled',
      partiallyStoppedAmount: 'Partially Stopped Amount',
      comments: 'Comments',
      existingOutcome: 'Existing Outcome',
      existingComments: 'Existing Comments',
      outcomeUpdatedDateOrTime: 'Outcome Updated Date/Time',
      outcomeUpdatedBy: 'Outcome Updated By',
      bin8: 'BIN8',
      preDisputeService: 'Pre-dispute Service',
      addEthocaEnrollment: 'New Ethoca Enrollment',
      editEthocaEnrollment: 'Edit Ethoca Enrollment',
      addRdrEnrollment: 'New RDR Enrollment',
      editRdrEnrollment: 'Edit RDR Enrollment',
      note: 'Note',
      enrollmentContent: 'Enrollment Content',
      alertReceived: 'Alert Received',
      outcomeSubmitted: 'Outcome Submitted',
      initiateActivation: 'Initiated',
      pendingActivation: 'Pending Enrollment',
      activing: 'Enrolling',
      actived: 'Enrolled',
      activeFailed: 'Disenrolled',
      initiateClose: 'Initiated',
      pendingClose: 'Pending Disenrollment',
      closing: 'Disenrolling',
      closed: 'Disenrolled',
      alertBatchOperateTips: 'Outcoming <b>{count}</b>, Duplicates <b>{duplicates}</b>.<br>Only the first final state outcome you provide for an Alert is the outcome that will be sent to the issuer.',
    },
    checkout: {
      explanation1: '1. For card payment, only the highest priority or the lowest priority is allowed;',
      explanation2: '2. The priority of payment methods other than cards can be dragged and dropped to adjust the priority. The higher the record, the higher it will be displayed at the checkout;',
      allDesc: 'ALL: Countries except specific countries',
      card: 'Card',
      highestPriority: 'Highest priority',
      lowestPriority: 'Lowest priority',
      cardSort: 'Card sorting',
      addCardSort: 'Add',
      addSort: 'Add',
      editSort: 'Edit',
      addBrand: 'Add brand',
      editBrand: 'Edit Brand',
      viewBrand: 'Brand details',
      brandName: 'Brand name',
      logo: 'Logo',
      mainColor: 'Main color',
      useWebsite: 'Apply to the following website',
      colorSelectTip: 'Button and color when selected',
      useWebsiteTip: '1. \'All websites\' means that all current and future websites will use this brand information;<br/> ' +
        '2. It does not support applying to both \'all websites\' and specific websites (ie: the same website Can only be associated with one brand);',
      noBrandTip: 'You haven\'t set up a brand yet, go ahead and add your brand~',
      pay: 'Pay',
      deleteBrandConfirm: 'Are you sure you want to delete this brand? After deletion, the brand settings of the corresponding website will become invalid. ',
      brandLogoTip: 'The requirements for the logo image are at least 130*130 pixels and the size does not exceed 500kb. Supported formats are JPG and PNG.',
      allWebsite: 'All websites',
      websiteErrorTip: 'It does not support applying to both \'all websites\' and specific websites (ie: the same website Can only be associated with one brand);',
      isDisplayOrderNo: 'Merchant order ID displayed at checkout',
      viewCancelBtn: 'Cancel payment at cashier',
      cancelReturn: 'Return to Merchant Page',
      viewCountryBtn: 'Switch country',
      customOptions: 'Custom options',
      selectCountry: 'Select country',
      orderNo: 'Order No',
      logoAndNameEmptyTips: 'The brand name and logo must have at least one filled out.',
      topDisplayOrderTips: 'Top display order: logo - brand name - URL. Display the store URL when the brand isn\'t set.',
    },
    currency: {
      CNY: 'CNY',
      JPY: 'JPY',
      GBP: 'GBP',
      CHF: 'CHF',
      CAD: 'CAD',
      HKD: 'HKD',
      FIM: 'FIM',
      IEP: 'IEP',
      LUF: 'LUF',
      PTE: 'PTE',
      IDR: 'IDR',
      NZD: 'NZD',
      SUR: 'SUR',
      KRW: 'KRW',
      USD: 'USD',
      EUR: 'EUR',
      DEM: 'DEM',
      FRF: 'FRF',
      AUD: 'AUD',
      ATS: 'ATS',
      BEF: 'BEF',
      ITL: 'ITL',
      NLG: 'NLG',
      ESP: 'ESP',
      MYR: 'MYR',
      PHP: 'PHP',
      SGD: 'SGD',
      THB: 'THB',
      BRL: 'BRL',
    },
    currencyDesc: {
      CNY: 'Chinese Yuan',
      JPY: 'Japanese Yen',
      GBP: 'British Pound',
      CHF: 'Swiss Franc',
      CAD: 'Canadian Dollar',
      HKD: 'Hong Kong Dollar',
      FIM: 'Finnish Markka',
      IEP: 'Irish Pound',
      LUF: 'Luxembourg Franc',
      PTE: 'Portuguese Escudo',
      IDR: 'Indonesian Rupiah',
      NZD: 'New Zealand Dollar',
      SUR: 'Russian Ruble',
      KRW: 'South Korean Won',
      USD: 'United States Dollar',
      EUR: 'Euro',
      DEM: 'German Mark',
      FRF: 'French Franc',
      AUD: 'Australian Dollar',
      ATS: 'Austrian Schilling',
      BEF: 'Belgian Franc',
      ITL: 'Italian Lira',
      NLG: 'Dutch Guilder',
      ESP: 'Spanish Peseta',
      MYR: 'Malaysian Ringgit',
      PHP: 'Philippine Peso',
      SGD: 'Singapore Dollar',
      THB: 'Thai Baht',
      BRL: 'Brazilian Real',
      VND: 'Vietnamese Dong',
      MXN: 'Mexican Peso',
      CNH: 'Offshore RMB',
    },
    developer: {
      alertNotifyTitle: 'Enrollment Notification',
      alertNotifyTips: 'Notification will be sent when enrollment status changed',
      notifyStatus: 'Status',
      selectNotifyType: 'Method:',
      notifyType: 'Method',
      webhook: 'Webhook',
      email: 'Email',
      SFTP: 'SFTP',
      alertFailureNotifyTitle: 'Malfunction Notification',
      alertFailureNotifyTips: 'Notification will be sent when enrollment exceeds 180 days without alerts/cases',
      ethocaAlertTitle: 'Ethoca Alerts',
      ethocaAlertTips: 'Ethoca Alerts',
      rdrAlertTitle: 'RDR Cases',
      rdrAlertTips: 'RDR Cases',
      enrolling: 'Enrolling',
      enrolled: 'Enrolled',
      enrollmentFailed: 'Enrollment Failed',
      disenrolling: 'Disenrolling',
      disenrolled: 'Disenrolled',
      fraudNotifyTitle: 'Fraud Notification',
      fraudNotifyTips: 'Sourced from payment networks that card issuers generate to flag fraudulent payments',
      // 拒付预警通知
      chargebackAlertTitle: 'Chargeback Warning Notification',
      // 拒付预警邮件通知
      chargebackWarningEmailNotifyTitle: 'Chargeback Warning Email Notification',
    },
    register: {
      summary: 'Summary',
      companyType: 'Business type',
      companyDetails: 'Business details',
      companyRepresentative: 'Director',
      companyOwner: 'Shareholders',
      websiteOrApplication: 'Website/App details',
      bankAccount: 'Bank account',
      status: 'Review and complete',
      businessLocation: 'Business location',
      typeOfBusiness: 'Type of business',
      businessTypeTips: 'Please choose an option',
      pleaseCheckAndSubmit: 'Please check and confirm your information.',
      submitAgreement: 'Submit and review',
      submitAgreementTips: 'By submitting this form, you agree to our <a href="https://www.onerway.com/privacy?lang=en" class="service-agreement">service agreement</a>, agree to receive SMS and email messages, and confirm that the information you provide is complete and accurate.',
      company: 'Company',
      partnership: 'Partnership',
      soleProprietorship: 'Sole Proprietorship',
      'limited_liability_partnership/LLP': 'Limited Liability Partnership/LLP',
      unincorporated_partnership: 'Unincorporated Partnership',
      private_company: 'Private Company',
      other: "Other/I'm not sure",
      submit_and_review: 'Review and submit',
      errorTitle: {
        input: 'English letters + numbers + half-width punctuation marks',
      },
      addAll: 'Add Shareholder',
      validaterBusiness: 'Verify your business',
      validateBusiness: {
        companyType: {
          descript1: 'Let’s start with some basics',
          descript2: 'Choose your location and business type to get started.',
        },
        companyDetails: {
          // 请提供进件公司信息
          descript1: 'Please provide information on the receiving company',
          descript2: 'Onerway collects this information to better understand and serve your business.',
        },
        companyRepresentative: {
          descript1: 'Verify you represent this business',
          descript2: 'This form must be filled out by someone with significant control and management of your business. If that’s not you, make sure to ask the right person to continue.',
        },
        companyOwner: {
          descript1: 'Shareholders',
          descript2: 'Due to regulatory guidelines, we’re required to collect information on anyone who has significant ownership (25% or more) of your business.',
        },
        websiteOrApplication: {
          descript1: 'Website/App details',
          descript2: 'Onerway collects this information to better understand and serve your business.',
        },
        bankAccount: {
          descript1: 'Add your bank to receive payouts',
          descript2: 'A payout is the transfer of funds from Onerway to your bank account.',
        },
      },
      companType: {
        referrer: 'referrer',
        referrer_placeHolder: 'Your referrer',
      },
      businessDetails: {
        legal_business_name: 'Legal business name',
        company_registration_number: 'Company registration number',
        company_registration_date: 'Company registration date',
        business_name: 'Business name',
        registered_business_address: 'Registered business address',
        business_phone_number: 'Business phone number',
        upload_company_certificates: 'Upload Company Certificates',
        legal_business_name_input_placeHolder: 'Must match the Tax ID',
        area: 'Area/City',
        location: 'Location',
        district: 'District',
        address_line_1: 'Address line 1',
        address_line_2: 'Address line 2',
        postal_code: 'Postal code',
        certificate_of_incorporation: 'Certificate of Incorporation',
        business_registration_certificate: 'Business Registration Certificate',
        'company_NNC1/NAR1': 'Company NNC1/NAR1',

        explanation_of_shareholding_structure: 'Explanation of shareholding structure',
        articles_of_association: 'Articles of association',
        extra_document_1: 'Extra Document 1',
        extra_document_2: 'Extra Document 2',
        extra_document_3: 'Extra Document 3',
        extra_document_4: 'Extra Document 4',
        extra_document_5: 'Extra Document 5',
        upload_limit: 'Maximum size not exceeding 10M, limited to JPG, PNG, JPEG formats',

      },
      companyRepresentative_desc: {
        legalName: 'Legal name',
        legalName_firstName: 'First name',
        legalName_lastName: 'Last name',
        email_address: 'Email Address',
        job_title: 'Job title',
        birthDate: 'Date of birth',
        home_address: 'Home address',
        phone_number: 'Phone number',
        personal_id_numbe: 'Personal ID number',
        personal_id_numbe_input_placeHolder: 'Government issued ID number',
        birthDUpload_Personal_id_imagesate: 'Upload Personal ID images',
        job_input_tips: 'CEO, Manager, Partner',
        passport: 'Passport',
        // 微信号
        wechat: 'Wechat',
        wechat_input_placeHolder: 'Wechat account',
        legalName_required: 'name is required',
      },
      websiteOrApplication_desc: {
        business_website: 'websiteOrApplication',
        duration_of_operation: 'Duration of operation',
        business_website_type: 'Business website type',
        website_default_domain: 'Website default domain',
        'industry/Business_category': 'Industry/Business category',
        'monthly_trading_volume (USD)': 'Monthly trading volume (USD)',
        monthly_dispute_rate: 'Dispute rate',
        monthly_refund_rate: 'Refund rate',
        market: 'Target regions',
        upload_business_proofs: 'Upload business proofs',
        'Transaction statements (last 3 months)': 'Transaction statements (last 3 months）',
        'Screenshots of business platforms': 'Screenshots of business platforms',
        placeholder: {
          'industry/Business_category': 'Please choose your industry',
          website_default_domain: 'i.e. xxx.myshopify.com',
        },
        options: {
          duration_of_operation: {
            new: 'New website',
            less_than_1_year: 'Less than 1 year',
            '1_to_3_years': '1 year ～ 3 years',
            more_than_3_years: 'More than 3 years',
          },
        },
      },
      bankAccount_desc: {
        bank_name: 'Account holder name',
        bank_address: 'Choose your bank',
        // 开户银行地址
        bank_account_location: 'Bank address',
        bank_account_name: 'Currency',
        bank_account_number_HK: 'Account number',
        bank_account_number_UK: 'IBAN',
        Currency: 'Currency',
        'Confirm account number': 'Confirm account number',
        'Upload bank statement': 'Upload bank statement',
        // 开户证明
        'Account Opening Proof': 'Proof of bank account',
        'Upload extra proofs': 'Upload extra proofs',
        placeholder: {
          bank_name: 'Must be consistent with the legal business name',
          bank_address: 'Search for your bank or SWIFT code',
          Currency: 'Please select currencies',
          bank_account_number_HK: '000123-456',
          bank_account_number_UK: 'GB61CLRB12345678909876',
          upload_extra_proofs: 'Please provide proofs if your business location differs from your bank',
          bank_account_location: 'Please input bank address',

        },
        descript: {
          application_submitted: 'Application submitted',
          descript_content: 'Your application has been submitted and Onerway staff is currently reviewing it. ' +
            'We may contact you or your company representative through your registered email or contact information regarding the completeness and authenticity of the materials.',
          descript_tips: 'Once the review is completed, we will notify you immediately. Thank you for your cooperation.',
        },
      },
      marketOptions: {
        hottest: 'Hottest',
        otherMarket: 'Other Market',
        northAmerica: 'North America',
        europe: 'Europe',
        eastAsia: 'East Asia',
        southeastAsia: 'Southeast Asia',
        middleEast: 'Middle East',
        latinAmerica: 'Latin America',
        africa: 'Africa',
        ceania: 'Oceania',
      },
      // 因为存在新老模板 这里问题 只能新增
      networkApplication: {
        guide: {
          title: 'Welcome to Onerway ’s Payment Service.',
          desc: 'Before you start filling out your information, we want to ensure you understand our pricing structure and the next steps in our partnership process.',
        },
        companyDetails: {
          business_name: 'Trading Name/Used Name',
        },
      },
    },
    countryList: {
      HK: 'Hong Kong SAR China',
      UK: 'United Kingdom',
    },
    // {
    //   label: '最热门',
    //   options: [{
    //     value: 'North America',
    //     label: '北美洲',
    //   }, {
    //     value: 'Europe',
    //     label: '欧洲',
    //   }],
    // },
    // {
    //   label: '其它市场',
    //   options: [{
    //     value: 'East Asia',
    //     label: '东亚',
    //   }, {
    //     value: 'Southeast Asia',
    //     label: '东南亚',
    //   },
    //   {
    //     value: 'Middle East',
    //     label: '中东地区',
    //   },
    //   {
    //     value: 'Latin America',
    //     label: '中南美洲',
    //   },
    //   {
    //     value: 'Africa',
    //     label: '非洲',
    //   },
    //   {
    //     value: 'Oceania',
    //     label: '大洋洲',
    //   },
    //   ],
    // },

    settingsSuccessfulTip: 'Setting succeeded',
    settingsFailedTip: 'Setting failed',
    downloadSuccessfulTip: 'Download successful',
    downloadFailedTip: 'Download failed',
    uploadSuccessfulTip: 'Upload successful',
    uploadFailedTip: 'Upload failed',
    submitSuccessfulTip: 'Submit successfully',
    submitFailedTip: 'Submit failed',
    operateSuccessfulTip: 'Successful operation',
    emptyUploadFileTip: 'Please select a file to upload',
    supportFileTip: 'Support {type} format',
    supportFileErrorTip: 'Only supports uploading {type} files',
    settings: {
      authCapture: {
        title: 'Auth-Capture Automation',
        saveBtn: 'Save changes',
        desc: 'The settings apply only to Auth transactions',
        captureRadio: 'Automatically Captured',
        voidRadio: 'Automatically Voided',
        notice: 'Notice',
        leaveTips: 'Unsaved changes detected. Do you want to leave this page without saving?',
        leaveConfirmText: 'Leave',
        leaveCancelText: 'Save before leaving',
      },
    },
    jumio: {
      sumbitTips: 'After face authentication of all the business owners passed, please submit this form to complete face authentication. ',
      leftTitle: 'Submit face authentication',
      sumbitBtn: 'Submit authentication information',
      sumbitLater: 'Submit later',
      Title: 'Business Owners',
      jumioTipsTitle: 'After completing all facial authentication steps, click submit at the bottom.',
      subTitle: 'Please ensure the authenticity, integrity, validity and clarity of the documents provided. <br/>If there are multiple beneficial owners, please add individuals holding more than 25% of the company’s shares.',
      add: 'Add business owner',
      adds: 'Add',
      status: {
        pending: 'waiting for authentication ',
        approved: 'passed',
        rejected: 'rejected',
        pending_scan: 'waiting for scan',
      },
      authenticated: 'Authenticated on',
      email: 'Authenticate via email',
      immediately: 'Face authentication',
      addTitle: 'Add Business Owner',
      addSubTitle: 'You can only add up to 5 directors and 5 beneficial owners.',
      refuseTitle: 'Delete business owner',
      refuseTips: 'The authentication information will be deleted as well.',
      editTitle: 'Edit Business Owner',
      atLeast: 'Please add at least one director and one beneficiary owner',
      allStauts: 'The system requires all company principals to complete facial verification for submission. Your inputs have been automatically saved. Note: Status updates may be delayed. You may exit and resubmit after confirmation of successful verification.',
      jumioPopTitle: 'Scan QR code to complete face authentication.',
      jumioTime: 'Please complete before <span class="time"  style="color:#6655F7">{time}</span> ',
      jumioTips: 'Notice',
      emailSendSuccess: 'Email sent successfully',
      jumioTipsContent: 'The status may be updated later due to system delays. You could close this dialog and continue to fill and submit the form.',
      jumioTipsContent2: 'If the link expires, please close this dialog and retrieve a new authentication QR code.',
      emailPoptitle: 'The link for face authentication will be sent to the director via email.',
      emailLabel: 'Email address',
      errTitle: 'Authentication rejected. Please modify the information.',
      delSus: 'Delete successfully',
      emailWarn: 'Authentication email was sent to {email} on {time}. If modifying the email address or the email was not received, please check the email address and resent.',
      infoTitle: 'Face Authentication',
      authPass: 'Completed',
    },
    guide: {
      activatePayouts: 'Activate Payouts',
      provide1: 'We provide a comprehensive',
      provide2: 'Real-Time Payments (RTP)',
      provide3: 'solution supporting over 20 major global currencies Upon completion of your Payouts service activation, we will automatically establish five default currency accounts for you:',
      provide4: 'USD, EUR, GBP, HKD, and CNH',
      activateBtn: 'Activate Payouts Now',
      info1Title: 'Fast Settlement',
      info1Desc: 'Quick payment processing with funds settlement as fast as 24 hours',
      info2Title: 'Multi-Currency Support',
      info2Desc: 'Support for over 20 major currencies to meet your global business needs',
      info3Title: 'Real-time Exchange Rates',
      info3Desc: 'Providing real-time market rates to ensure you get the best exchange service',
      info4Title: 'Secure & Reliable',
      info4Desc: 'Bank-level security measures to protect your funds',
    },
    // Fraud Notification Module
    fraudNotification: {
      title: 'Fraud Notification',
      notificationId: 'Notification ID',
      notifiedTime: 'Notified Time',
      receivedTime: 'Received Time',
      fraudType: 'Fraud Type',
      transactionId: 'TXN ID',
      transactionAmount: 'TXN Amount',
      paymentMethod: 'Payment Method',
      disputePresence: 'Chargeback Status',
      chargebackId: 'Chargeback ID',
      refundType: 'Refund Type',
      refundId: 'Refund ID',
      received: 'Received',
      fraudNotificationTips: 'Notifications of Fraud (NoF) are sourced from payment networks that card issuers on the networks generate to flag payments they suspect might be fraudulent. Please note that fraud/dispute can be filed before NoF is received.',
    },
    // 欺诈通知详情页面英文多语言配置 / Fraud notification details page English i18n configuration
    fraudNotificationDetails: {
      pageTitle: 'Details', // 欺诈通知详情
      notificationDetails: 'Notification Details', // 欺诈通知信息
      transactionDetails: 'Transaction Details', // 源交易信息
      id: 'ID', // ID
      notifiedTime: 'Notified Time', // 发起时间
      notifiedTimeTip: 'Since NoF come from multiple sources, the time format may vary.', // 欺诈通知存在多个来源，时间格式可能存在差异。
      receivedTime: 'Received Time', // 接收时间
      fraudType: 'Fraud Type', // 欺诈类型
      amount: 'Amount', // 金额
      currency: 'Currency', // 币种
      transactionId: 'ID', // 流水号
      transactionTime: 'Time', // 交易时间
      paymentMethod: 'Payment Method', // 支付方式
      chargebackStatus: 'Chargeback Status', // 拒付状态
      chargebackId: 'Chargeback ID', // 拒付ID
      refundType: 'Refund Type', // 退款类型
      refundId: 'Refund ID', // 退款ID
      invalidId: 'Invalid ID parameter', // ID参数无效
    },
    transapproval: {
      securityTitle: 'Transfer Approval Security Settings',
      securityDesc: 'To ensure the security of your single and batch transfers, you can set up approval requirements based on transfer amounts.',
      securityDesc2: 'Users with the permission to access "Transfers" can be assigned as approvers.',
      editSettingsNow: 'Edit settings now',
      transferApprovalSettings: 'Transfer approval settings',
      noSetup: 'No setup',
      setupComplete: 'Setup complete',
      setupPending: 'Disabled',
      existingTransferApprovals: 'Existing transfer approvals can be viewed in',
      transfers: 'Transfers',
      approvalConditions: 'Approval conditions',
      noApprovalCondition: 'There is no approval condition yet.',
      additionalSettings: 'Additional settings',
      noAdditionalSetting: 'There is no additional setting yet.',
      amountCurrency: 'Amount currency',
      lastModified: 'Last modified',
      lastModifiedBy: 'Last modified by',
      approveSelfFlag: 'Allow approving self-submitted tickets',
      allowApproveMultiStepFlag: 'Allow multi-step approval by same person',
      deleteConditionConfirm: 'Are you sure you want to delete this approval condition?',
      edit: 'Edit',
      disable: 'Disable',
      enable: 'Enable',
      enabled: 'Enabled',
      viewIn: ' to view',
      noConditionsSet: 'You have not set any approval conditions yet',
      disableWarning: 'Disabling payment approval settings will prevent future payment approvals, which may cause security issues.',
      confirmDisable: 'Confirm Disable Settings',
      keepEnabled: 'Keep Enabled',
      disableSuccess: 'Payment approval settings disabled successfully',
      enableSuccess: 'Payment approval settings enabled successfully',
      fillApprovers: 'Please select approvers',
      keepAtLeastOneStep: 'At least one approval step must be kept',
      transferAmount: 'Transfer Amount',
      editPaymentApproval: 'Edit Payment Approval',
      approvalFlowCurrency: 'Approval Flow Currency',
      usd: 'US Dollar',
      currencyConversionInfo: 'Payment amounts in all other currencies will be automatically converted to the approval flow currency (USD) based on current exchange rates to determine the approval process.',
      approvalConditionsTitle: 'Approval Conditions',
      maxFiveConditions: 'You can add up to 5 conditions',
      editStep: 'Edit',
      confirmStep: 'Confirm',
      loadApprovalFlowFailed: 'Failed to load approval flow data',
      saveFailed: 'Save failed',
      pleaseCompleteConditions: 'Please complete all approval condition information',
      allowSelfApproval: 'Allow users to approve their own payments',
      allowMultiStepSameUser: 'Allow same user to handle multiple approval steps',
      cancel: 'Cancel',
      // Phase 1: Zero-risk texts
      forTransfersAnyAmount: 'For transfers of any amount',
      forTransfersLessThan: 'For transfers less than',
      forTransfersGreaterEqual: 'For transfers greater than and equal to',
      addStep: 'Add step',
      addCondition: 'Add Condition',
      maxFiveConditionsLimit: 'You can add up to 5 conditions.',
      approvalFlow: 'Approval flow',
      requireApprovalFrom: 'Require approval from',
      conditionTitle: 'Condition',
      approvalIs: ', approval is',
      // Validation messages
      pleaseSelectCurrency: 'Please select a currency.',
      pleaseSelectApprovalRequired: 'Please select if approval is required or not.',
      pleaseSelectApprovalMode: 'Please select approval mode.',
      pleaseEnterAmount: 'Please enter the amount.',
      pleaseEnterValidAmount: 'Please enter a valid amount.',
      pleaseEnterAmountLessThan: 'Please enter an amount less than 100,000,000.',
      amountMustBeGreater: 'Amount must be greater than condition',
      amount: 'amount',
      // Phase 2: Option labels
      required: 'required',
      notRequired: 'not required',
      anyOf: 'any of',
      allOf: 'all of',
      // confirm page
      confirmPaymentApprovalSettings: 'Confirm Payment Approval Settings',
      existingTransfersNotice: 'Existing transfers will still follow the previous approval settings. Only new transfers will apply requested settings.',
      approvalConditionSettings: 'Approval Condition Settings',
      existingApprovalSettings: 'Existing Approval Settings',
      newApprovalSettings: 'New Approval Settings',
      previousStep: 'Previous Step',
      save: 'Save',
      saveAndActivate: 'Save and Activate',
      saveSuccess: 'Save successful',
      saveAndActivateSuccess: 'Save and activate successful',
      // For commented out content (if enabled in future)
      otherSettings: 'Other Settings',
      allowUserApproveOwnPayments: 'Allow users to approve their own payments',
      allowSameUserMultipleSteps: 'Allow same user to handle multiple approval steps',
    },
  },
  ...enLocale,
};
